{
  "1": {
    "pointgroup_international": "C1",
    "schoenflies": "C1^1",
    "pointgroup_schoenflies": "1",
    "international_short": "P1",
    "translations": [[0.0, 0.0, 0.0]],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 1,
    "choice": "",
    "international_full": "P 1",
    "hall_symbol": "P 1",
    "international": "P 1",
    "arithmetic_crystal_class_number": 1,
    "arithmetic_crystal_class_symbol": "1P"
  },
  "2": {
    "pointgroup_international": "Ci",
    "schoenflies": "Ci^1",
    "pointgroup_schoenflies": "-1",
    "international_short": "P-1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 2,
    "choice": "",
    "international_full": "P -1",
    "hall_symbol": "-P 1",
    "international": "P -1",
    "arithmetic_crystal_class_number": 2,
    "arithmetic_crystal_class_symbol": "-1P"
  },
  "3": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^1",
    "pointgroup_schoenflies": "2",
    "international_short": "P2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 3,
    "choice": "b",
    "international_full": "P 1 2 1",
    "hall_symbol": "P 2y",
    "international": "P 2 = P 1 2 1",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "4": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^1",
    "pointgroup_schoenflies": "2",
    "international_short": "P2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 3,
    "choice": "c",
    "international_full": "P 1 1 2",
    "hall_symbol": "P 2",
    "international": "P 2 = P 1 1 2",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "5": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^1",
    "pointgroup_schoenflies": "2",
    "international_short": "P2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 3,
    "choice": "a",
    "international_full": "P 2 1 1",
    "hall_symbol": "P 2x",
    "international": "P 2 = P 2 1 1",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "6": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^2",
    "pointgroup_schoenflies": "2",
    "international_short": "P2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 4,
    "choice": "b",
    "international_full": "P 1 2_1 1",
    "hall_symbol": "P 2yb",
    "international": "P 2_1 = P 1 2_1 1",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "7": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^2",
    "pointgroup_schoenflies": "2",
    "international_short": "P2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 4,
    "choice": "c",
    "international_full": "P 1 1 2_1",
    "hall_symbol": "P 2c",
    "international": "P 2_1 = P 1 1 2_1",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "8": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^2",
    "pointgroup_schoenflies": "2",
    "international_short": "P2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 4,
    "choice": "a",
    "international_full": "P 2_1 1 1",
    "hall_symbol": "P 2xa",
    "international": "P 2_1 = P 2_1 1 1",
    "arithmetic_crystal_class_number": 3,
    "arithmetic_crystal_class_symbol": "2P"
  },
  "9": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "b1",
    "international_full": "C 1 2 1",
    "hall_symbol": "C 2y",
    "international": "C 2 = C 1 2 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "10": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "b2",
    "international_full": "A 1 2 1",
    "hall_symbol": "A 2y",
    "international": "C 2 = A 1 2 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "11": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "b3",
    "international_full": "I 1 2 1",
    "hall_symbol": "I 2y",
    "international": "C 2 = I 1 2 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "12": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 5,
    "choice": "c1",
    "international_full": "A 1 1 2",
    "hall_symbol": "A 2",
    "international": "C 2 = A 1 1 2",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "13": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 5,
    "choice": "c2",
    "international_full": "B 1 1 2",
    "hall_symbol": "B 2",
    "international": "C 2 = B 1 1 2 = B 2",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "14": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 5,
    "choice": "c3",
    "international_full": "I 1 1 2",
    "hall_symbol": "I 2",
    "international": "C 2 = I 1 1 2",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "15": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "a1",
    "international_full": "B 2 1 1",
    "hall_symbol": "B 2x",
    "international": "C 2 = B 2 1 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "16": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "a2",
    "international_full": "C 2 1 1",
    "hall_symbol": "C 2x",
    "international": "C 2 = C 2 1 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "17": {
    "pointgroup_international": "C2",
    "schoenflies": "C2^3",
    "pointgroup_schoenflies": "2",
    "international_short": "C2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 5,
    "choice": "a3",
    "international_full": "I 2 1 1",
    "hall_symbol": "I 2x",
    "international": "C 2 = I 2 1 1",
    "arithmetic_crystal_class_number": 4,
    "arithmetic_crystal_class_symbol": "2C"
  },
  "18": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^1",
    "pointgroup_schoenflies": "m",
    "international_short": "Pm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 6,
    "choice": "b",
    "international_full": "P 1 m 1",
    "hall_symbol": "P -2y",
    "international": "P m = P 1 m 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "19": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^1",
    "pointgroup_schoenflies": "m",
    "international_short": "Pm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 6,
    "choice": "c",
    "international_full": "P 1 1 m",
    "hall_symbol": "P -2",
    "international": "P m = P 1 1 m",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "20": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^1",
    "pointgroup_schoenflies": "m",
    "international_short": "Pm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 6,
    "choice": "a",
    "international_full": "P m 1 1",
    "hall_symbol": "P -2x",
    "international": "P m = P m 1 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "21": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "b1",
    "international_full": "P 1 c 1",
    "hall_symbol": "P -2yc",
    "international": "P c = P 1 c 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "22": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "b2",
    "international_full": "P 1 n 1",
    "hall_symbol": "P -2yac",
    "international": "P c = P 1 n 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "23": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "b3",
    "international_full": "P 1 a 1",
    "hall_symbol": "P -2ya",
    "international": "P c = P 1 a 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "24": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 7,
    "choice": "c1",
    "international_full": "P 1 1 a",
    "hall_symbol": "P -2a",
    "international": "P c = P 1 1 a",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "25": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 7,
    "choice": "c2",
    "international_full": "P 1 1 n",
    "hall_symbol": "P -2ab",
    "international": "P c = P 1 1 n",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "26": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 7,
    "choice": "c3",
    "international_full": "P 1 1 b",
    "hall_symbol": "P -2b",
    "international": "P c = P 1 1 b = P b",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "27": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "a1",
    "international_full": "P b 1 1",
    "hall_symbol": "P -2xb",
    "international": "P c = P b 1 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "28": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "a2",
    "international_full": "P n 1 1",
    "hall_symbol": "P -2xbc",
    "international": "P c = P n 1 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "29": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^2",
    "pointgroup_schoenflies": "m",
    "international_short": "Pc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 7,
    "choice": "a3",
    "international_full": "P c 1 1",
    "hall_symbol": "P -2xc",
    "international": "P c = P c 1 1",
    "arithmetic_crystal_class_number": 5,
    "arithmetic_crystal_class_symbol": "mP"
  },
  "30": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "b1",
    "international_full": "C 1 m 1",
    "hall_symbol": "C -2y",
    "international": "C m = C 1 m 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "31": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "b2",
    "international_full": "A 1 m 1",
    "hall_symbol": "A -2y",
    "international": "C m = A 1 m 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "32": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "b3",
    "international_full": "I 1 m 1",
    "hall_symbol": "I -2y",
    "international": "C m = I 1 m 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "33": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 8,
    "choice": "c1",
    "international_full": "A 1 1 m",
    "hall_symbol": "A -2",
    "international": "C m = A 1 1 m",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "34": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 8,
    "choice": "c2",
    "international_full": "B 1 1 m",
    "hall_symbol": "B -2",
    "international": "C m = B 1 1 m = B m",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "35": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 8,
    "choice": "c3",
    "international_full": "I 1 1 m",
    "hall_symbol": "I -2",
    "international": "C m = I 1 1 m",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "36": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "a1",
    "international_full": "B m 1 1",
    "hall_symbol": "B -2x",
    "international": "C m = B m 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "37": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "a2",
    "international_full": "C m 1 1",
    "hall_symbol": "C -2x",
    "international": "C m = C m 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "38": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^3",
    "pointgroup_schoenflies": "m",
    "international_short": "Cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 8,
    "choice": "a3",
    "international_full": "I m 1 1",
    "hall_symbol": "I -2x",
    "international": "C m = I m 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "39": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "b1",
    "international_full": "C 1 c 1",
    "hall_symbol": "C -2yc",
    "international": "C c = C 1 c 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "40": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "b2",
    "international_full": "A 1 n 1",
    "hall_symbol": "A -2yac",
    "international": "C c = A 1 n 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "41": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "b3",
    "international_full": "I 1 a 1",
    "hall_symbol": "I -2ya",
    "international": "C c = I 1 a 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "42": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-b1",
    "international_full": "A 1 a 1",
    "hall_symbol": "A -2ya",
    "international": "C c = A 1 a 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "43": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-b2",
    "international_full": "C 1 n 1",
    "hall_symbol": "C -2ybc",
    "international": "C c = C 1 n 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "44": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-b3",
    "international_full": "I 1 c 1",
    "hall_symbol": "I -2yc",
    "international": "C c = I 1 c 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "45": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "c1",
    "international_full": "A 1 1 a",
    "hall_symbol": "A -2a",
    "international": "C c = A 1 1 a",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "46": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "c2",
    "international_full": "B 1 1 n",
    "hall_symbol": "B -2bc",
    "international": "C c = B 1 1 n",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "47": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "c3",
    "international_full": "I 1 1 b",
    "hall_symbol": "I -2b",
    "international": "C c = I 1 1 b",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "48": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "-c1",
    "international_full": "B 1 1 b",
    "hall_symbol": "B -2b",
    "international": "C c = B 1 1 b = B b",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "49": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "-c2",
    "international_full": "A 1 1 n",
    "hall_symbol": "A -2ac",
    "international": "C c = A 1 1 n",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "50": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 9,
    "choice": "-c3",
    "international_full": "I 1 1 a",
    "hall_symbol": "I -2a",
    "international": "C c = I 1 1 a",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "51": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "a1",
    "international_full": "B b 1 1",
    "hall_symbol": "B -2xb",
    "international": "C c = B b 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "52": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "a2",
    "international_full": "C n 1 1",
    "hall_symbol": "C -2xbc",
    "international": "C c = C n 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "53": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "a3",
    "international_full": "I c 1 1",
    "hall_symbol": "I -2xc",
    "international": "C c = I c 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "54": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-a1",
    "international_full": "C c 1 1",
    "hall_symbol": "C -2xc",
    "international": "C c = C c 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "55": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-a2",
    "international_full": "B n 1 1",
    "hall_symbol": "B -2xbc",
    "international": "C c = B n 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "56": {
    "pointgroup_international": "Cs",
    "schoenflies": "Cs^4",
    "pointgroup_schoenflies": "m",
    "international_short": "Cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 9,
    "choice": "-a3",
    "international_full": "I b 1 1",
    "hall_symbol": "I -2xb",
    "international": "C c = I b 1 1",
    "arithmetic_crystal_class_number": 6,
    "arithmetic_crystal_class_symbol": "mC"
  },
  "57": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^1",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 10,
    "choice": "b",
    "international_full": "P 1 2/m 1",
    "hall_symbol": "-P 2y",
    "international": "P 2/m = P 1 2/m 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "58": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^1",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 10,
    "choice": "c",
    "international_full": "P 1 1 2/m",
    "hall_symbol": "-P 2",
    "international": "P 2/m = P 1 1 2/m",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "59": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^1",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 10,
    "choice": "a",
    "international_full": "P 2/m 1 1",
    "hall_symbol": "-P 2x",
    "international": "P 2/m = P 2/m 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "60": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^2",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 11,
    "choice": "b",
    "international_full": "P 1 2_1/m 1",
    "hall_symbol": "-P 2yb",
    "international": "P 2_1/m = P 1 2_1/m 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "61": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^2",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 11,
    "choice": "c",
    "international_full": "P 1 1 2_1/m",
    "hall_symbol": "-P 2c",
    "international": "P 2_1/m = P 1 1 2_1/m",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "62": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^2",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 11,
    "choice": "a",
    "international_full": "P 2_1/m 1 1",
    "hall_symbol": "-P 2xa",
    "international": "P 2_1/m = P 2_1/m 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "63": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "b1",
    "international_full": "C 1 2/m 1",
    "hall_symbol": "-C 2y",
    "international": "C 2/m = C 1 2/m 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "64": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "b2",
    "international_full": "A 1 2/m 1",
    "hall_symbol": "-A 2y",
    "international": "C 2/m = A 1 2/m 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "65": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "b3",
    "international_full": "I 1 2/m 1",
    "hall_symbol": "-I 2y",
    "international": "C 2/m = I 1 2/m 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "66": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 12,
    "choice": "c1",
    "international_full": "A 1 1 2/m",
    "hall_symbol": "-A 2",
    "international": "C 2/m = A 1 1 2/m",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "67": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 12,
    "choice": "c2",
    "international_full": "B 1 1 2/m",
    "hall_symbol": "-B 2",
    "international": "C 2/m = B 1 1 2/m = B 2/m",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "68": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 12,
    "choice": "c3",
    "international_full": "I 1 1 2/m",
    "hall_symbol": "-I 2",
    "international": "C 2/m = I 1 1 2/m",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "69": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "a1",
    "international_full": "B 2/m 1 1",
    "hall_symbol": "-B 2x",
    "international": "C 2/m = B 2/m 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "70": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "a2",
    "international_full": "C 2/m 1 1",
    "hall_symbol": "-C 2x",
    "international": "C 2/m = C 2/m 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "71": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^3",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 12,
    "choice": "a3",
    "international_full": "I 2/m 1 1",
    "hall_symbol": "-I 2x",
    "international": "C 2/m = I 2/m 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "72": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "b1",
    "international_full": "P 1 2/c 1",
    "hall_symbol": "-P 2yc",
    "international": "P 2/c = P 1 2/c 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "73": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "b2",
    "international_full": "P 1 2/n 1",
    "hall_symbol": "-P 2yac",
    "international": "P 2/c = P 1 2/n 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "74": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "b3",
    "international_full": "P 1 2/a 1",
    "hall_symbol": "-P 2ya",
    "international": "P 2/c = P 1 2/a 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "75": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 13,
    "choice": "c1",
    "international_full": "P 1 1 2/a",
    "hall_symbol": "-P 2a",
    "international": "P 2/c = P 1 1 2/a",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "76": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 13,
    "choice": "c2",
    "international_full": "P 1 1 2/n",
    "hall_symbol": "-P 2ab",
    "international": "P 2/c = P 1 1 2/n",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "77": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 13,
    "choice": "c3",
    "international_full": "P 1 1 2/b",
    "hall_symbol": "-P 2b",
    "international": "P 2/c = P 1 1 2/b = P 2/b",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "78": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "a1",
    "international_full": "P 2/b 1 1",
    "hall_symbol": "-P 2xb",
    "international": "P 2/c = P 2/b 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "79": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "a2",
    "international_full": "P 2/n 1 1",
    "hall_symbol": "-P 2xbc",
    "international": "P 2/c = P 2/n 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "80": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^4",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 13,
    "choice": "a3",
    "international_full": "P 2/c 1 1",
    "hall_symbol": "-P 2xc",
    "international": "P 2/c = P 2/c 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "81": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "b1",
    "international_full": "P 1 2_1/c 1",
    "hall_symbol": "-P 2ybc",
    "international": "P 2_1/c = P 1 2_1/c 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "82": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "b2",
    "international_full": "P 1 2_1/n 1",
    "hall_symbol": "-P 2yn",
    "international": "P 2_1/c = P 1 2_1/n 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "83": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "b3",
    "international_full": "P 1 2_1/a 1",
    "hall_symbol": "-P 2yab",
    "international": "P 2_1/c = P 1 2_1/a 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "84": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 14,
    "choice": "c1",
    "international_full": "P 1 1 2_1/a",
    "hall_symbol": "-P 2ac",
    "international": "P 2_1/c = P 1 1 2_1/a",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "85": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 14,
    "choice": "c2",
    "international_full": "P 1 1 2_1/n",
    "hall_symbol": "-P 2n",
    "international": "P 2_1/c = P 1 1 2_1/n",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "86": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 14,
    "choice": "c3",
    "international_full": "P 1 1 2_1/b",
    "hall_symbol": "-P 2bc",
    "international": "P 2_1/c = P 1 1 2_1/b = P 2_1/b",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "87": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "a1",
    "international_full": "P 2_1/b 1 1",
    "hall_symbol": "-P 2xab",
    "international": "P 2_1/c = P 2_1/b 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "88": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "a2",
    "international_full": "P 2_1/n 1 1",
    "hall_symbol": "-P 2xn",
    "international": "P 2_1/c = P 2_1/n 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "89": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^5",
    "pointgroup_schoenflies": "2/m",
    "international_short": "P2_1/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 14,
    "choice": "a3",
    "international_full": "P 2_1/c 1 1",
    "hall_symbol": "-P 2xac",
    "international": "P 2_1/c = P 2_1/c 1 1",
    "arithmetic_crystal_class_number": 7,
    "arithmetic_crystal_class_symbol": "2/mP"
  },
  "90": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "b1",
    "international_full": "C 1 2/c 1",
    "hall_symbol": "-C 2yc",
    "international": "C 2/c = C 1 2/c 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "91": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "b2",
    "international_full": "A 1 2/n 1",
    "hall_symbol": "-A 2yac",
    "international": "C 2/c = A 1 2/n 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "92": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "b3",
    "international_full": "I 1 2/a 1",
    "hall_symbol": "-I 2ya",
    "international": "C 2/c = I 1 2/a 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "93": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-b1",
    "international_full": "A 1 2/a 1",
    "hall_symbol": "-A 2ya",
    "international": "C 2/c = A 1 2/a 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "94": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-b2",
    "international_full": "C 1 2/n 1",
    "hall_symbol": "-C 2ybc",
    "international": "C 2/c = C 1 2/n 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "95": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-b3",
    "international_full": "I 1 2/c 1",
    "hall_symbol": "-I 2yc",
    "international": "C 2/c = I 1 2/c 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "96": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "c1",
    "international_full": "A 1 1 2/a",
    "hall_symbol": "-A 2a",
    "international": "C 2/c = A 1 1 2/a",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "97": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "c2",
    "international_full": "B 1 1 2/n",
    "hall_symbol": "-B 2bc",
    "international": "C 2/c = B 1 1 2/n",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "98": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "c3",
    "international_full": "I 1 1 2/b",
    "hall_symbol": "-I 2b",
    "international": "C 2/c = I 1 1 2/b",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "99": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "-c1",
    "international_full": "B 1 1 2/b",
    "hall_symbol": "-B 2b",
    "international": "C 2/c = B 1 1 2/b = B 2/b",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "100": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "-c2",
    "international_full": "A 1 1 2/n",
    "hall_symbol": "-A 2ac",
    "international": "C 2/c = A 1 1 2/n",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "101": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 15,
    "choice": "-c3",
    "international_full": "I 1 1 2/a",
    "hall_symbol": "-I 2a",
    "international": "C 2/c = I 1 1 2/a",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "102": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "a1",
    "international_full": "B 2/b 1 1",
    "hall_symbol": "-B 2xb",
    "international": "C 2/c = B 2/b 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "103": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "a2",
    "international_full": "C 2/n 1 1",
    "hall_symbol": "-C 2xbc",
    "international": "C 2/c = C 2/n 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "104": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "a3",
    "international_full": "I 2/c 1 1",
    "hall_symbol": "-I 2xc",
    "international": "C 2/c = I 2/c 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "105": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-a1",
    "international_full": "C 2/c 1 1",
    "hall_symbol": "-C 2xc",
    "international": "C 2/c = C 2/c 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "106": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-a2",
    "international_full": "B 2/n 1 1",
    "hall_symbol": "-B 2xbc",
    "international": "C 2/c = B 2/n 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "107": {
    "pointgroup_international": "C2h",
    "schoenflies": "C2h^6",
    "pointgroup_schoenflies": "2/m",
    "international_short": "C2/c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 15,
    "choice": "-a3",
    "international_full": "I 2/b 1 1",
    "hall_symbol": "-I 2xb",
    "international": "C 2/c = I 2/b 1 1",
    "arithmetic_crystal_class_number": 8,
    "arithmetic_crystal_class_symbol": "2/mC"
  },
  "108": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^1",
    "pointgroup_schoenflies": "222",
    "international_short": "P222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 16,
    "choice": "",
    "international_full": "P 2 2 2",
    "hall_symbol": "P 2 2",
    "international": "P 2 2 2",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "109": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^2",
    "pointgroup_schoenflies": "222",
    "international_short": "P222_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 17,
    "choice": "",
    "international_full": "P 2 2 2_1",
    "hall_symbol": "P 2c 2",
    "international": "P 2 2 2_1",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "110": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^2",
    "pointgroup_schoenflies": "222",
    "international_short": "P2_122",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 17,
    "choice": "cab",
    "international_full": "P 2_1 2 2",
    "hall_symbol": "P 2a 2a",
    "international": "P 2_1 2 2",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "111": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^2",
    "pointgroup_schoenflies": "222",
    "international_short": "P22_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 17,
    "choice": "bca",
    "international_full": "P 2 2_1 2",
    "hall_symbol": "P 2 2b",
    "international": "P 2 2_1 2",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "112": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^3",
    "pointgroup_schoenflies": "222",
    "international_short": "P2_12_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 18,
    "choice": "",
    "international_full": "P 2_1 2_1 2",
    "hall_symbol": "P 2 2ab",
    "international": "P 2_1 2_1 2",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "113": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^3",
    "pointgroup_schoenflies": "222",
    "international_short": "P22_12_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 18,
    "choice": "cab",
    "international_full": "P 2 2_1 2_1",
    "hall_symbol": "P 2bc 2",
    "international": "P 2 2_1 2_1",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "114": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^3",
    "pointgroup_schoenflies": "222",
    "international_short": "P2_122_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 18,
    "choice": "bca",
    "international_full": "P 2_1 2 2_1",
    "hall_symbol": "P 2ac 2ac",
    "international": "P 2_1 2 2_1",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "115": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^4",
    "pointgroup_schoenflies": "222",
    "international_short": "P2_12_12_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 19,
    "choice": "",
    "international_full": "P 2_1 2_1 2_1",
    "hall_symbol": "P 2ac 2ab",
    "international": "P 2_1 2_1 2_1",
    "arithmetic_crystal_class_number": 9,
    "arithmetic_crystal_class_symbol": "222P"
  },
  "116": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^5",
    "pointgroup_schoenflies": "222",
    "international_short": "C222_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 20,
    "choice": "",
    "international_full": "C 2 2 2_1",
    "hall_symbol": "C 2c 2",
    "international": "C 2 2 2_1",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "117": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^5",
    "pointgroup_schoenflies": "222",
    "international_short": "A2_122",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 20,
    "choice": "cab",
    "international_full": "A 2_1 2 2",
    "hall_symbol": "A 2a 2a",
    "international": "A 2_1 2 2",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "118": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^5",
    "pointgroup_schoenflies": "222",
    "international_short": "B22_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 20,
    "choice": "bca",
    "international_full": "B 2 2_1 2",
    "hall_symbol": "B 2 2b",
    "international": "B 2 2_1 2",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "119": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^6",
    "pointgroup_schoenflies": "222",
    "international_short": "C222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 21,
    "choice": "",
    "international_full": "C 2 2 2",
    "hall_symbol": "C 2 2",
    "international": "C 2 2 2",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "120": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^6",
    "pointgroup_schoenflies": "222",
    "international_short": "A222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 21,
    "choice": "cab",
    "international_full": "A 2 2 2",
    "hall_symbol": "A 2 2",
    "international": "A 2 2 2",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "121": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^6",
    "pointgroup_schoenflies": "222",
    "international_short": "B222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 21,
    "choice": "bca",
    "international_full": "B 2 2 2",
    "hall_symbol": "B 2 2",
    "international": "B 2 2 2",
    "arithmetic_crystal_class_number": 10,
    "arithmetic_crystal_class_symbol": "222C"
  },
  "122": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^7",
    "pointgroup_schoenflies": "222",
    "international_short": "F222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 22,
    "choice": "",
    "international_full": "F 2 2 2",
    "hall_symbol": "F 2 2",
    "international": "F 2 2 2",
    "arithmetic_crystal_class_number": 11,
    "arithmetic_crystal_class_symbol": "222F"
  },
  "123": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^8",
    "pointgroup_schoenflies": "222",
    "international_short": "I222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 23,
    "choice": "",
    "international_full": "I 2 2 2",
    "hall_symbol": "I 2 2",
    "international": "I 2 2 2",
    "arithmetic_crystal_class_number": 12,
    "arithmetic_crystal_class_symbol": "222I"
  },
  "124": {
    "pointgroup_international": "D2",
    "schoenflies": "D2^9",
    "pointgroup_schoenflies": "222",
    "international_short": "I2_12_12_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 24,
    "choice": "",
    "international_full": "I 2_1 2_1 2_1",
    "hall_symbol": "I 2b 2c",
    "international": "I 2_1 2_1 2_1",
    "arithmetic_crystal_class_number": 12,
    "arithmetic_crystal_class_symbol": "222I"
  },
  "125": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^1",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pmm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 25,
    "choice": "",
    "international_full": "P m m 2",
    "hall_symbol": "P 2 -2",
    "international": "P m m 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "126": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^1",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 25,
    "choice": "cab",
    "international_full": "P 2 m m",
    "hall_symbol": "P -2 2",
    "international": "P 2 m m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "127": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^1",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pm2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 25,
    "choice": "bca",
    "international_full": "P m 2 m",
    "hall_symbol": "P -2 -2",
    "international": "P m 2 m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "128": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pmc2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 26,
    "choice": "",
    "international_full": "P m c 2_1",
    "hall_symbol": "P 2c -2",
    "international": "P m c 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "129": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pcm2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 26,
    "choice": "ba-c",
    "international_full": "P c m 2_1",
    "hall_symbol": "P 2c -2c",
    "international": "P c m 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "130": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1ma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 26,
    "choice": "cab",
    "international_full": "P 2_1 m a",
    "hall_symbol": "P -2a 2a",
    "international": "P 2_1 m a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "131": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1am",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 26,
    "choice": "-cba",
    "international_full": "P 2_1 a m",
    "hall_symbol": "P -2 2a",
    "international": "P 2_1 a m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "132": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pb2_1m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 26,
    "choice": "bca",
    "international_full": "P b 2_1 m",
    "hall_symbol": "P -2 -2b",
    "international": "P b 2_1 m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "133": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^2",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pm2_1b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 26,
    "choice": "a-cb",
    "international_full": "P m 2_1 b",
    "hall_symbol": "P -2b -2",
    "international": "P m 2_1 b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "134": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^3",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pcc2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 27,
    "choice": "",
    "international_full": "P c c 2",
    "hall_symbol": "P 2 -2c",
    "international": "P c c 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "135": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^3",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2aa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 27,
    "choice": "cab",
    "international_full": "P 2 a a",
    "hall_symbol": "P -2a 2",
    "international": "P 2 a a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "136": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^3",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pb2b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 27,
    "choice": "bca",
    "international_full": "P b 2 b",
    "hall_symbol": "P -2b -2b",
    "international": "P b 2 b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "137": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pma2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 28,
    "choice": "",
    "international_full": "P m a 2",
    "hall_symbol": "P 2 -2a",
    "international": "P m a 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "138": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pbm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 28,
    "choice": "ba-c",
    "international_full": "P b m 2",
    "hall_symbol": "P 2 -2b",
    "international": "P b m 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "139": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2mb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 28,
    "choice": "cab",
    "international_full": "P 2 m b",
    "hall_symbol": "P -2b 2",
    "international": "P 2 m b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "140": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 28,
    "choice": "-cba",
    "international_full": "P 2 c m",
    "hall_symbol": "P -2c 2",
    "international": "P 2 c m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "141": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pc2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 28,
    "choice": "bca",
    "international_full": "P c 2 m",
    "hall_symbol": "P -2c -2c",
    "international": "P c 2 m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "142": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^4",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pm2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 28,
    "choice": "a-cb",
    "international_full": "P m 2 a",
    "hall_symbol": "P -2a -2a",
    "international": "P m 2 a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "143": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pca2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 29,
    "choice": "",
    "international_full": "P c a 2_1",
    "hall_symbol": "P 2c -2ac",
    "international": "P c a 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "144": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pbc2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 29,
    "choice": "ba-c",
    "international_full": "P b c 2_1",
    "hall_symbol": "P 2c -2b",
    "international": "P b c 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "145": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1ab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 29,
    "choice": "cab",
    "international_full": "P 2_1 a b",
    "hall_symbol": "P -2b 2a",
    "international": "P 2_1 a b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "146": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1ca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 29,
    "choice": "-cba",
    "international_full": "P 2_1 c a",
    "hall_symbol": "P -2ac 2a",
    "international": "P 2_1 c a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "147": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pc2_1b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 29,
    "choice": "bca",
    "international_full": "P c 2_1 b",
    "hall_symbol": "P -2bc -2c",
    "international": "P c 2_1 b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "148": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^5",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pb2_1a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 29,
    "choice": "a-cb",
    "international_full": "P b 2_1 a",
    "hall_symbol": "P -2a -2ab",
    "international": "P b 2_1 a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "149": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pnc2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 30,
    "choice": "",
    "international_full": "P n c 2",
    "hall_symbol": "P 2 -2bc",
    "international": "P n c 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "150": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pcn2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 30,
    "choice": "ba-c",
    "international_full": "P c n 2",
    "hall_symbol": "P 2 -2ac",
    "international": "P c n 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "151": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2na",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 30,
    "choice": "cab",
    "international_full": "P 2 n a",
    "hall_symbol": "P -2ac 2",
    "international": "P 2 n a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "152": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2an",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 30,
    "choice": "-cba",
    "international_full": "P 2 a n",
    "hall_symbol": "P -2ab 2",
    "international": "P 2 a n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "153": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pb2n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 30,
    "choice": "bca",
    "international_full": "P b 2 n",
    "hall_symbol": "P -2ab -2ab",
    "international": "P b 2 n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "154": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^6",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pn2b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 30,
    "choice": "a-cb",
    "international_full": "P n 2 b",
    "hall_symbol": "P -2bc -2bc",
    "international": "P n 2 b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "155": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pmn2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 31,
    "choice": "",
    "international_full": "P m n 2_1",
    "hall_symbol": "P 2ac -2",
    "international": "P m n 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "156": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pnm2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 31,
    "choice": "ba-c",
    "international_full": "P n m 2_1",
    "hall_symbol": "P 2bc -2bc",
    "international": "P n m 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "157": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1mn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 31,
    "choice": "cab",
    "international_full": "P 2_1 m n",
    "hall_symbol": "P -2ab 2ab",
    "international": "P 2_1 m n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "158": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1nm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 31,
    "choice": "-cba",
    "international_full": "P 2_1 n m",
    "hall_symbol": "P -2 2ac",
    "international": "P 2_1 n m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "159": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pn2_1m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 31,
    "choice": "bca",
    "international_full": "P n 2_1 m",
    "hall_symbol": "P -2 -2bc",
    "international": "P n 2_1 m",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "160": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^7",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pm2_1n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 31,
    "choice": "a-cb",
    "international_full": "P m 2_1 n",
    "hall_symbol": "P -2ab -2",
    "international": "P m 2_1 n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "161": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^8",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pba2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 32,
    "choice": "",
    "international_full": "P b a 2",
    "hall_symbol": "P 2 -2ab",
    "international": "P b a 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "162": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^8",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2cb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 32,
    "choice": "cab",
    "international_full": "P 2 c b",
    "hall_symbol": "P -2bc 2",
    "international": "P 2 c b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "163": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^8",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pc2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 32,
    "choice": "bca",
    "international_full": "P c 2 a",
    "hall_symbol": "P -2ac -2ac",
    "international": "P c 2 a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "164": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pna2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 33,
    "choice": "",
    "international_full": "P n a 2_1",
    "hall_symbol": "P 2c -2n",
    "international": "P n a 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "165": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pbn2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 33,
    "choice": "ba-c",
    "international_full": "P b n 2_1",
    "hall_symbol": "P 2c -2ab",
    "international": "P b n 2_1",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "166": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1nb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 33,
    "choice": "cab",
    "international_full": "P 2_1 n b",
    "hall_symbol": "P -2bc 2a",
    "international": "P 2_1 n b",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "167": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2_1cn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 33,
    "choice": "-cba",
    "international_full": "P 2_1 c n",
    "hall_symbol": "P -2n 2a",
    "international": "P 2_1 c n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "168": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pc2_1n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 33,
    "choice": "bca",
    "international_full": "P c 2_1 n",
    "hall_symbol": "P -2n -2ac",
    "international": "P c 2_1 n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "169": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^9",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pn2_1a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 33,
    "choice": "a-cb",
    "international_full": "P n 2_1 a",
    "hall_symbol": "P -2ac -2n",
    "international": "P n 2_1 a",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "170": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^10",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pnn2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 34,
    "choice": "",
    "international_full": "P n n 2",
    "hall_symbol": "P 2 -2n",
    "international": "P n n 2",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "171": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^10",
    "pointgroup_schoenflies": "mm2",
    "international_short": "P2nn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 34,
    "choice": "cab",
    "international_full": "P 2 n n",
    "hall_symbol": "P -2n 2",
    "international": "P 2 n n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "172": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^10",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Pn2n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 34,
    "choice": "bca",
    "international_full": "P n 2 n",
    "hall_symbol": "P -2n -2n",
    "international": "P n 2 n",
    "arithmetic_crystal_class_number": 13,
    "arithmetic_crystal_class_symbol": "mm2P"
  },
  "173": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^11",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cmm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 35,
    "choice": "",
    "international_full": "C m m 2",
    "hall_symbol": "C 2 -2",
    "international": "C m m 2",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "174": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^11",
    "pointgroup_schoenflies": "mm2",
    "international_short": "A2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 35,
    "choice": "cab",
    "international_full": "A 2 m m",
    "hall_symbol": "A -2 2",
    "international": "A 2 m m",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "175": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^11",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bm2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 35,
    "choice": "bca",
    "international_full": "B m 2 m",
    "hall_symbol": "B -2 -2",
    "international": "B m 2 m",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "176": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cmc2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 36,
    "choice": "",
    "international_full": "C m c 2_1",
    "hall_symbol": "C 2c -2",
    "international": "C m c 2_1",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "177": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ccm2_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 36,
    "choice": "ba-c",
    "international_full": "C c m 2_1",
    "hall_symbol": "C 2c -2c",
    "international": "C c m 2_1",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "178": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "A2_1ma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 36,
    "choice": "cab",
    "international_full": "A 2_1 m a",
    "hall_symbol": "A -2a 2a",
    "international": "A 2_1 m a",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "179": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "A2_1am",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 36,
    "choice": "-cba",
    "international_full": "A 2_1 a m",
    "hall_symbol": "A -2 2a",
    "international": "A 2_1 a m",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "180": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bb2_1m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 36,
    "choice": "bca",
    "international_full": "B b 2_1 m",
    "hall_symbol": "B -2 -2b",
    "international": "B b 2_1 m",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "181": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^12",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bm2_1b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 36,
    "choice": "a-cb",
    "international_full": "B m 2_1 b",
    "hall_symbol": "B -2b -2",
    "international": "B m 2_1 b",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "182": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^13",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ccc2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 37,
    "choice": "",
    "international_full": "C c c 2",
    "hall_symbol": "C 2 -2c",
    "international": "C c c 2",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "183": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^13",
    "pointgroup_schoenflies": "mm2",
    "international_short": "A2aa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 37,
    "choice": "cab",
    "international_full": "A 2 a a",
    "hall_symbol": "A -2a 2",
    "international": "A 2 a a",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "184": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^13",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bb2b",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 37,
    "choice": "bca",
    "international_full": "B b 2 b",
    "hall_symbol": "B -2b -2b",
    "international": "B b 2 b",
    "arithmetic_crystal_class_number": 14,
    "arithmetic_crystal_class_symbol": "mm2C"
  },
  "185": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Amm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 38,
    "choice": "",
    "international_full": "A m m 2",
    "hall_symbol": "A 2 -2",
    "international": "A m m 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "186": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bmm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 38,
    "choice": "ba-c",
    "international_full": "B m m 2",
    "hall_symbol": "B 2 -2",
    "international": "B m m 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "187": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "B2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 38,
    "choice": "cab",
    "international_full": "B 2 m m",
    "hall_symbol": "B -2 2",
    "international": "B 2 m m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "188": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "C2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 38,
    "choice": "-cba",
    "international_full": "C 2 m m",
    "hall_symbol": "C -2 2",
    "international": "C 2 m m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "189": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cm2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 38,
    "choice": "bca",
    "international_full": "C m 2 m",
    "hall_symbol": "C -2 -2",
    "international": "C m 2 m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "190": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^14",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Am2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 38,
    "choice": "a-cb",
    "international_full": "A m 2 m",
    "hall_symbol": "A -2 -2",
    "international": "A m 2 m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "191": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Aem2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 39,
    "choice": "",
    "international_full": "A e m 2",
    "hall_symbol": "A 2 -2c",
    "international": "A e m 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "192": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bme2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 39,
    "choice": "ba-c",
    "international_full": "B m e 2",
    "hall_symbol": "B 2 -2c",
    "international": "B m e 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "193": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "B2em",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 39,
    "choice": "cab",
    "international_full": "B 2 e m",
    "hall_symbol": "B -2c 2",
    "international": "B 2 e m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "194": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "C2me",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 39,
    "choice": "-cba",
    "international_full": "C 2 m e",
    "hall_symbol": "C -2b 2",
    "international": "C 2 m e",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "195": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cm2e",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 39,
    "choice": "bca",
    "international_full": "C m 2 e",
    "hall_symbol": "C -2b -2b",
    "international": "C m 2 e",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "196": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^15",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ae2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 39,
    "choice": "a-cb",
    "international_full": "A e 2 m",
    "hall_symbol": "A -2c -2c",
    "international": "A e 2 m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "197": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ama2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 40,
    "choice": "",
    "international_full": "A m a 2",
    "hall_symbol": "A 2 -2a",
    "international": "A m a 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "198": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bbm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 40,
    "choice": "ba-c",
    "international_full": "B b m 2",
    "hall_symbol": "B 2 -2b",
    "international": "B b m 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "199": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "B2mb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 40,
    "choice": "cab",
    "international_full": "B 2 m b",
    "hall_symbol": "B -2b 2",
    "international": "B 2 m b",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "200": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "C2cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 40,
    "choice": "-cba",
    "international_full": "C 2 c m",
    "hall_symbol": "C -2c 2",
    "international": "C 2 c m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "201": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cc2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 40,
    "choice": "bca",
    "international_full": "C c 2 m",
    "hall_symbol": "C -2c -2c",
    "international": "C c 2 m",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "202": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^16",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Am2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 40,
    "choice": "a-cb",
    "international_full": "A m 2 a",
    "hall_symbol": "A -2a -2a",
    "international": "A m 2 a",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "203": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Aea2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 41,
    "choice": "",
    "international_full": "A e a 2",
    "hall_symbol": "A 2 -2ac",
    "international": "A e a 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "204": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Bbe2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 41,
    "choice": "ba-c",
    "international_full": "B b e 2",
    "hall_symbol": "B 2 -2bc",
    "international": "B b e 2",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "205": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "B2eb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 41,
    "choice": "cab",
    "international_full": "B 2 e b",
    "hall_symbol": "B -2bc 2",
    "international": "B 2 e b",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "206": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "C2ce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 41,
    "choice": "-cba",
    "international_full": "C 2 c e",
    "hall_symbol": "C -2bc 2",
    "international": "C 2 c e",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "207": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Cc2e",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 41,
    "choice": "bca",
    "international_full": "C c 2 e",
    "hall_symbol": "C -2bc -2bc",
    "international": "C c 2 e",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "208": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^17",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ae2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 41,
    "choice": "a-cb",
    "international_full": "A e 2 a",
    "hall_symbol": "A -2ac -2ac",
    "international": "A e 2 a",
    "arithmetic_crystal_class_number": 15,
    "arithmetic_crystal_class_symbol": "2mmC"
  },
  "209": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^18",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Fmm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 42,
    "choice": "",
    "international_full": "F m m 2",
    "hall_symbol": "F 2 -2",
    "international": "F m m 2",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "210": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^18",
    "pointgroup_schoenflies": "mm2",
    "international_short": "F2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 42,
    "choice": "cab",
    "international_full": "F 2 m m",
    "hall_symbol": "F -2 2",
    "international": "F 2 m m",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "211": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^18",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Fm2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 42,
    "choice": "bca",
    "international_full": "F m 2 m",
    "hall_symbol": "F -2 -2",
    "international": "F m 2 m",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "212": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^19",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Fdd2",
    "translations": [
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 43,
    "choice": "",
    "international_full": "F d d 2",
    "hall_symbol": "F 2 -2d",
    "international": "F d d 2",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "213": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^19",
    "pointgroup_schoenflies": "mm2",
    "international_short": "F2dd",
    "translations": [
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 43,
    "choice": "cab",
    "international_full": "F 2 d d",
    "hall_symbol": "F -2d 2",
    "international": "F 2 d d",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "214": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^19",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Fd2d",
    "translations": [
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 43,
    "choice": "bca",
    "international_full": "F d 2 d",
    "hall_symbol": "F -2d -2d",
    "international": "F d 2 d",
    "arithmetic_crystal_class_number": 16,
    "arithmetic_crystal_class_symbol": "mm2F"
  },
  "215": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^20",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Imm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 44,
    "choice": "",
    "international_full": "I m m 2",
    "hall_symbol": "I 2 -2",
    "international": "I m m 2",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "216": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^20",
    "pointgroup_schoenflies": "mm2",
    "international_short": "I2mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 44,
    "choice": "cab",
    "international_full": "I 2 m m",
    "hall_symbol": "I -2 2",
    "international": "I 2 m m",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "217": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^20",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Im2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 44,
    "choice": "bca",
    "international_full": "I m 2 m",
    "hall_symbol": "I -2 -2",
    "international": "I m 2 m",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "218": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^21",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Iba2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 45,
    "choice": "",
    "international_full": "I b a 2",
    "hall_symbol": "I 2 -2c",
    "international": "I b a 2",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "219": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^21",
    "pointgroup_schoenflies": "mm2",
    "international_short": "I2cb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 45,
    "choice": "cab",
    "international_full": "I 2 c b",
    "hall_symbol": "I -2a 2",
    "international": "I 2 c b",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "220": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^21",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ic2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 45,
    "choice": "bca",
    "international_full": "I c 2 a",
    "hall_symbol": "I -2b -2b",
    "international": "I c 2 a",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "221": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ima2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 46,
    "choice": "",
    "international_full": "I m a 2",
    "hall_symbol": "I 2 -2a",
    "international": "I m a 2",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "222": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ibm2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 46,
    "choice": "ba-c",
    "international_full": "I b m 2",
    "hall_symbol": "I 2 -2b",
    "international": "I b m 2",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "223": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "I2mb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 46,
    "choice": "cab",
    "international_full": "I 2 m b",
    "hall_symbol": "I -2b 2",
    "international": "I 2 m b",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "224": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "I2cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 46,
    "choice": "-cba",
    "international_full": "I 2 c m",
    "hall_symbol": "I -2c 2",
    "international": "I 2 c m",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "225": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Ic2m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 46,
    "choice": "bca",
    "international_full": "I c 2 m",
    "hall_symbol": "I -2c -2c",
    "international": "I c 2 m",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "226": {
    "pointgroup_international": "C2v",
    "schoenflies": "C2v^22",
    "pointgroup_schoenflies": "mm2",
    "international_short": "Im2a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 46,
    "choice": "a-cb",
    "international_full": "I m 2 a",
    "hall_symbol": "I -2a -2a",
    "international": "I m 2 a",
    "arithmetic_crystal_class_number": 17,
    "arithmetic_crystal_class_symbol": "mm2I"
  },
  "227": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^1",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 47,
    "choice": "",
    "international_full": "P 2/m 2/m 2/m",
    "hall_symbol": "-P 2 2",
    "international": "P m m m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "228": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^2",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnnn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 48,
    "choice": "1",
    "international_full": "P 2/n 2/n 2/n",
    "hall_symbol": "P 2 2 -1n",
    "international": "P n n n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "229": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^2",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnnn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 48,
    "choice": "2",
    "international_full": "P 2/n 2/n 2/n",
    "hall_symbol": "-P 2ab 2bc",
    "international": "P n n n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "230": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^3",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pccm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 49,
    "choice": "",
    "international_full": "P 2/c 2/c 2/m",
    "hall_symbol": "-P 2 2c",
    "international": "P c c m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "231": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^3",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 49,
    "choice": "cab",
    "international_full": "P 2/m 2/a 2/a",
    "hall_symbol": "-P 2a 2",
    "international": "P m a a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "232": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^3",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 49,
    "choice": "bca",
    "international_full": "P 2/b 2/m 2/b",
    "hall_symbol": "-P 2b 2b",
    "international": "P b m b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "233": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pban",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "1",
    "international_full": "P 2/b 2/a 2/n",
    "hall_symbol": "P 2 2 -1ab",
    "international": "P b a n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "234": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pban",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "2",
    "international_full": "P 2/b 2/a 2/n",
    "hall_symbol": "-P 2ab 2b",
    "international": "P b a n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "235": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pncb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "1cab",
    "international_full": "P 2/n 2/c 2/b",
    "hall_symbol": "P 2 2 -1bc",
    "international": "P n c b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "236": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pncb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "2cab",
    "international_full": "P 2/n 2/c 2/b",
    "hall_symbol": "-P 2b 2bc",
    "international": "P n c b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "237": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcna",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "1bca",
    "international_full": "P 2/c 2/n 2/a",
    "hall_symbol": "P 2 2 -1ac",
    "international": "P c n a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "238": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^4",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcna",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 50,
    "choice": "2bca",
    "international_full": "P 2/c 2/n 2/a",
    "hall_symbol": "-P 2a 2c",
    "international": "P c n a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "239": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "",
    "international_full": "P 2_1/m 2/m 2/a",
    "hall_symbol": "-P 2a 2a",
    "international": "P m m a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "240": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "ba-c",
    "international_full": "P 2/m 2_1/m 2/b",
    "hall_symbol": "-P 2b 2",
    "international": "P m m b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "241": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "cab",
    "international_full": "P 2/b 2_1/m 2/m",
    "hall_symbol": "-P 2 2b",
    "international": "P b m m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "242": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "-cba",
    "international_full": "P 2/c 2/m 2_1/m",
    "hall_symbol": "-P 2c 2c",
    "international": "P c m m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "243": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "bca",
    "international_full": "P 2/m 2/c 2_1/m",
    "hall_symbol": "-P 2c 2",
    "international": "P m c m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "244": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^5",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 51,
    "choice": "a-cb",
    "international_full": "P 2_1/m 2/a 2/m",
    "hall_symbol": "-P 2 2a",
    "international": "P m a m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "245": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnna",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "",
    "international_full": "P 2/n 2_1/n 2/a",
    "hall_symbol": "-P 2a 2bc",
    "international": "P n n a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "246": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnnb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "ba-c",
    "international_full": "P 2_1/n 2/n 2/b",
    "hall_symbol": "-P 2b 2n",
    "international": "P n n b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "247": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbnn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "cab",
    "international_full": "P 2/b 2/n 2_1/n",
    "hall_symbol": "-P 2n 2b",
    "international": "P b n n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "248": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcnn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "-cba",
    "international_full": "P 2/c 2_1/n 2/n",
    "hall_symbol": "-P 2ab 2c",
    "international": "P c n n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "249": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pncn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "bca",
    "international_full": "P 2_1/n 2/c 2/n",
    "hall_symbol": "-P 2ab 2n",
    "international": "P n c n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "250": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^6",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnan",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 52,
    "choice": "a-cb",
    "international_full": "P 2/n 2/a 2_1/n",
    "hall_symbol": "-P 2n 2bc",
    "international": "P n a n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "251": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmna",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "",
    "international_full": "P 2/m 2/n 2_1/a",
    "hall_symbol": "-P 2ac 2",
    "international": "P m n a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "252": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "ba-c",
    "international_full": "P 2/n 2/m 2_1/b",
    "hall_symbol": "-P 2bc 2bc",
    "international": "P n m b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "253": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbmn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "cab",
    "international_full": "P 2_1/b 2/m 2/n",
    "hall_symbol": "-P 2ab 2ab",
    "international": "P b m n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "254": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "-cba",
    "international_full": "P 2_1/c 2/n 2/m",
    "hall_symbol": "-P 2 2ac",
    "international": "P c n m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "255": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pncm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "bca",
    "international_full": "P 2/n 2_1/c 2/m",
    "hall_symbol": "-P 2 2bc",
    "international": "P n c m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "256": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^7",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pman",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 53,
    "choice": "a-cb",
    "international_full": "P 2/m 2_1/a 2/n",
    "hall_symbol": "-P 2ab 2",
    "international": "P m a n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "257": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "",
    "international_full": "P 2_1/c 2/c 2/a",
    "hall_symbol": "-P 2a 2ac",
    "international": "P c c a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "258": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pccb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "ba-c",
    "international_full": "P 2/c 2_1/c 2/b",
    "hall_symbol": "-P 2b 2c",
    "international": "P c c b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "259": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "cab",
    "international_full": "P 2/b 2_1/a 2/a",
    "hall_symbol": "-P 2a 2b",
    "international": "P b a a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "260": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "-cba",
    "international_full": "P 2/c 2/a 2_1/a",
    "hall_symbol": "-P 2ac 2c",
    "international": "P c a a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "261": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbcb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "bca",
    "international_full": "P 2/b 2/c 2_1/b",
    "hall_symbol": "-P 2bc 2b",
    "international": "P b c b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "262": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^8",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 54,
    "choice": "a-cb",
    "international_full": "P 2_1/b 2/a 2/b",
    "hall_symbol": "-P 2b 2ab",
    "international": "P b a b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "263": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^9",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 55,
    "choice": "",
    "international_full": "P 2_1/b 2_1/a 2/m",
    "hall_symbol": "-P 2 2ab",
    "international": "P b a m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "264": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^9",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmcb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 55,
    "choice": "cab",
    "international_full": "P 2/m 2_1/c 2_1/b",
    "hall_symbol": "-P 2bc 2",
    "international": "P m c b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "265": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^9",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 55,
    "choice": "bca",
    "international_full": "P 2_1/c 2/m 2_1/a",
    "hall_symbol": "-P 2ac 2ac",
    "international": "P c m a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "266": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^10",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pccn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 56,
    "choice": "",
    "international_full": "P 2_1/c 2_1/c 2/n",
    "hall_symbol": "-P 2ab 2ac",
    "international": "P c c n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "267": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^10",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 56,
    "choice": "cab",
    "international_full": "P 2/n 2_1/a 2_1/a",
    "hall_symbol": "-P 2ac 2bc",
    "international": "P n a a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "268": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^10",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbnb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 56,
    "choice": "bca",
    "international_full": "P 2_1/b 2/n 2_1/b",
    "hall_symbol": "-P 2bc 2ab",
    "international": "P b n b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "269": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "",
    "international_full": "P 2/b 2_1/c 2_1/m",
    "hall_symbol": "-P 2c 2b",
    "international": "P b c m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "270": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "ba-c",
    "international_full": "P 2_1/c 2/a 2_1/m",
    "hall_symbol": "-P 2c 2ac",
    "international": "P c a m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "271": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "cab",
    "international_full": "P 2_1/m 2/c 2_1/a",
    "hall_symbol": "-P 2ac 2a",
    "international": "P m c a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "272": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "-cba",
    "international_full": "P 2_1/m 2_1/a 2/b",
    "hall_symbol": "-P 2b 2a",
    "international": "P m a b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "273": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "bca",
    "international_full": "P 2_1/b 2_1/m 2/a",
    "hall_symbol": "-P 2a 2ab",
    "international": "P b m a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "274": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^11",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 57,
    "choice": "a-cb",
    "international_full": "P 2/c 2_1/m 2_1/b",
    "hall_symbol": "-P 2bc 2c",
    "international": "P c m b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "275": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^12",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 58,
    "choice": "",
    "international_full": "P 2_1/n 2_1/n 2/m",
    "hall_symbol": "-P 2 2n",
    "international": "P n n m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "276": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^12",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmnn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 58,
    "choice": "cab",
    "international_full": "P 2/m 2_1/n 2_1/n",
    "hall_symbol": "-P 2n 2",
    "international": "P m n n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "277": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^12",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnmn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 58,
    "choice": "bca",
    "international_full": "P 2_1/n 2/m 2_1/n",
    "hall_symbol": "-P 2n 2n",
    "international": "P n m n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "278": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmmn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "1",
    "international_full": "P 2_1/m 2_1/m 2/n",
    "hall_symbol": "P 2 2ab -1ab",
    "international": "P m m n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "279": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmmn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "2",
    "international_full": "P 2_1/m 2_1/m 2/n",
    "hall_symbol": "-P 2ab 2a",
    "international": "P m m n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "280": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "1cab",
    "international_full": "P 2/n 2_1/m 2_1/m",
    "hall_symbol": "P 2bc 2 -1bc",
    "international": "P n m m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "281": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "2cab",
    "international_full": "P 2/n 2_1/m 2_1/m",
    "hall_symbol": "-P 2c 2bc",
    "international": "P n m m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "282": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "1bca",
    "international_full": "P 2_1/m 2/n 2_1/m",
    "hall_symbol": "P 2ac 2ac -1ac",
    "international": "P m n m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "283": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^13",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 59,
    "choice": "2bca",
    "international_full": "P 2_1/m 2/n 2_1/m",
    "hall_symbol": "-P 2c 2a",
    "international": "P m n m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "284": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbcn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "",
    "international_full": "P 2_1/b 2/c 2_1/n",
    "hall_symbol": "-P 2n 2ab",
    "international": "P b c n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "285": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcan",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "ba-c",
    "international_full": "P 2/c 2_1/a 2_1/n",
    "hall_symbol": "-P 2n 2c",
    "international": "P c a n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "286": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "cab",
    "international_full": "P 2_1/n 2_1/c 2/a",
    "hall_symbol": "-P 2a 2n",
    "international": "P n c a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "287": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "-cba",
    "international_full": "P 2_1/n 2/a 2_1/b",
    "hall_symbol": "-P 2bc 2n",
    "international": "P n a b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "288": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbna",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "bca",
    "international_full": "P 2/b 2_1/n 2_1/a",
    "hall_symbol": "-P 2ac 2b",
    "international": "P b n a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "289": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^14",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcnb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 60,
    "choice": "a-cb",
    "international_full": "P 2_1/c 2_1/n 2/b",
    "hall_symbol": "-P 2b 2ac",
    "international": "P c n b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "290": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^15",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 61,
    "choice": "",
    "international_full": "P 2_1/b 2_1/c 2_1/a",
    "hall_symbol": "-P 2ac 2ab",
    "international": "P b c a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "291": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^15",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 61,
    "choice": "ba-c",
    "international_full": "P 2_1/c 2_1/a 2_1/b",
    "hall_symbol": "-P 2bc 2ac",
    "international": "P c a b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "292": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "",
    "international_full": "P 2_1/n 2_1/m 2_1/a",
    "hall_symbol": "-P 2ac 2n",
    "international": "P n m a",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "293": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmnb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "ba-c",
    "international_full": "P 2_1/m 2_1/n 2_1/b",
    "hall_symbol": "-P 2bc 2a",
    "international": "P m n b",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "294": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pbnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "cab",
    "international_full": "P 2_1/b 2_1/n 2_1/m",
    "hall_symbol": "-P 2c 2ab",
    "international": "P b n m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "295": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pcmn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "-cba",
    "international_full": "P 2_1/c 2_1/m 2_1/n",
    "hall_symbol": "-P 2n 2ac",
    "international": "P c m n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "296": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pmcn",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "bca",
    "international_full": "P 2_1/m 2_1/c 2_1/n",
    "hall_symbol": "-P 2n 2a",
    "international": "P m c n",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "297": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^16",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Pnam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 62,
    "choice": "a-cb",
    "international_full": "P 2_1/n 2_1/a 2_1/m",
    "hall_symbol": "-P 2c 2n",
    "international": "P n a m",
    "arithmetic_crystal_class_number": 18,
    "arithmetic_crystal_class_symbol": "mmmP"
  },
  "298": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cmcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "",
    "international_full": "C 2/m 2/c 2_1/m",
    "hall_symbol": "-C 2c 2",
    "international": "C m c m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "299": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "ba-c",
    "international_full": "C 2/c 2/m 2_1/m",
    "hall_symbol": "-C 2c 2c",
    "international": "C c m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "300": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Amma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "cab",
    "international_full": "A 2_1/m 2/m 2/a",
    "hall_symbol": "-A 2a 2a",
    "international": "A m m a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "301": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Amam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "-cba",
    "international_full": "A 2_1/m 2/a 2/m",
    "hall_symbol": "-A 2 2a",
    "international": "A m a m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "302": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "bca",
    "international_full": "B 2/b 2_1/m 2/m",
    "hall_symbol": "-B 2 2b",
    "international": "B b m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "303": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^17",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bmmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 63,
    "choice": "a-cb",
    "international_full": "B 2/m 2_1/m 2/b",
    "hall_symbol": "-B 2b 2",
    "international": "B m m b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "304": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cmce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "",
    "international_full": "C 2/m 2/c 2_1/e",
    "hall_symbol": "-C 2bc 2",
    "international": "C m c e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "305": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccme",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "ba-c",
    "international_full": "C 2/c 2/m 2_1/e",
    "hall_symbol": "-C 2bc 2bc",
    "international": "C c m e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "306": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aema",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "cab",
    "international_full": "A 2_1/e 2/m 2/a",
    "hall_symbol": "-A 2ac 2ac",
    "international": "A e m a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "307": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aeam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "-cba",
    "international_full": "A 2_1/e 2/a 2/m",
    "hall_symbol": "-A 2 2ac",
    "international": "A e a m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "308": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbem",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "bca",
    "international_full": "B 2/b 2_1/e 2/m",
    "hall_symbol": "-B 2 2bc",
    "international": "B b e m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "309": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^18",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bmeb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 64,
    "choice": "a-cb",
    "international_full": "B 2/m 2_1/e 2/b",
    "hall_symbol": "-B 2bc 2",
    "international": "B m e b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "310": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^19",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cmmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 65,
    "choice": "",
    "international_full": "C 2/m 2/m 2/m",
    "hall_symbol": "-C 2 2",
    "international": "C m m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "311": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^19",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ammm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 65,
    "choice": "cab",
    "international_full": "A 2/m 2/m 2/m",
    "hall_symbol": "-A 2 2",
    "international": "A m m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "312": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^19",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bmmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 65,
    "choice": "bca",
    "international_full": "B 2/m 2/m 2/m",
    "hall_symbol": "-B 2 2",
    "international": "B m m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "313": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^20",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cccm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 66,
    "choice": "",
    "international_full": "C 2/c 2/c 2/m",
    "hall_symbol": "-C 2 2c",
    "international": "C c c m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "314": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^20",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Amaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 66,
    "choice": "cab",
    "international_full": "A 2/m 2/a 2/a",
    "hall_symbol": "-A 2a 2",
    "international": "A m a a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "315": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^20",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbmb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 66,
    "choice": "bca",
    "international_full": "B 2/b 2/m 2/b",
    "hall_symbol": "-B 2b 2b",
    "international": "B b m b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "316": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cmme",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "",
    "international_full": "C 2/m 2/m 2/e",
    "hall_symbol": "-C 2b 2",
    "international": "C m m e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "317": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Cmme",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "ba-c",
    "international_full": "C 2/m 2/m 2/e",
    "hall_symbol": "-C 2b 2b",
    "international": "C m m e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "318": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aemm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "cab",
    "international_full": "A 2/e 2/m 2/m",
    "hall_symbol": "-A 2c 2c",
    "international": "A e m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "319": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aemm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "-cba",
    "international_full": "A 2/e 2/m 2/m",
    "hall_symbol": "-A 2 2c",
    "international": "A e m m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "320": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bmem",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "bca",
    "international_full": "B 2/m 2/e 2/m",
    "hall_symbol": "-B 2 2c",
    "international": "B m e m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "321": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^21",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bmem",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 67,
    "choice": "a-cb",
    "international_full": "B 2/m 2/e 2/m",
    "hall_symbol": "-B 2c 2",
    "international": "B m e m",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "322": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1",
    "international_full": "C 2/c 2/c 2/e",
    "hall_symbol": "C 2 2 -1bc",
    "international": "C c c e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "323": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2",
    "international_full": "C 2/c 2/c 2/e",
    "hall_symbol": "-C 2b 2bc",
    "international": "C c c e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "324": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1ba-c",
    "international_full": "C 2/c 2/c 2/e",
    "hall_symbol": "C 2 2 -1bc",
    "international": "C c c e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "325": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ccce",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2ba-c",
    "international_full": "C 2/c 2/c 2/e",
    "hall_symbol": "-C 2b 2c",
    "international": "C c c e",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "326": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aeaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1cab",
    "international_full": "A 2/e 2/a 2/a",
    "hall_symbol": "A 2 2 -1ac",
    "international": "A e a a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "327": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aeaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2cab",
    "international_full": "A 2/e 2/a 2/a",
    "hall_symbol": "-A 2a 2c",
    "international": "A e a a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "328": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aeaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1-cba",
    "international_full": "A 2/e 2/a 2/a",
    "hall_symbol": "A 2 2 -1ac",
    "international": "A e a a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "329": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Aeaa",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2-cba",
    "international_full": "A 2/e 2/a 2/a",
    "hall_symbol": "-A 2ac 2c",
    "international": "A e a a",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "330": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbeb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1bca",
    "international_full": "B 2/b 2/e 2/b",
    "hall_symbol": "B 2 2 -1bc",
    "international": "B b e b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "331": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbcb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2bca",
    "international_full": "B 2/b 2/e 2/b",
    "hall_symbol": "-B 2bc 2b",
    "international": "B b c b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "332": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbeb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "1a-cb",
    "international_full": "B 2/b 2/e 2/b",
    "hall_symbol": "B 2 2 -1bc",
    "international": "B b e b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "333": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^22",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Bbeb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 68,
    "choice": "2a-cb",
    "international_full": "B 2/b 2/e 2/b",
    "hall_symbol": "-B 2b 2bc",
    "international": "B b e b",
    "arithmetic_crystal_class_number": 19,
    "arithmetic_crystal_class_symbol": "mmmC"
  },
  "334": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^23",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Fmmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 69,
    "choice": "",
    "international_full": "F 2/m 2/m 2/m",
    "hall_symbol": "-F 2 2",
    "international": "F m m m",
    "arithmetic_crystal_class_number": 20,
    "arithmetic_crystal_class_symbol": "mmmF"
  },
  "335": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^24",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Fddd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 70,
    "choice": "1",
    "international_full": "F 2/d 2/d 2/d",
    "hall_symbol": "F 2 2 -1d",
    "international": "F d d d",
    "arithmetic_crystal_class_number": 20,
    "arithmetic_crystal_class_symbol": "mmmF"
  },
  "336": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^24",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Fddd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 70,
    "choice": "2",
    "international_full": "F 2/d 2/d 2/d",
    "hall_symbol": "-F 2uv 2vw",
    "international": "F d d d",
    "arithmetic_crystal_class_number": 20,
    "arithmetic_crystal_class_symbol": "mmmF"
  },
  "337": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^25",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Immm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 71,
    "choice": "",
    "international_full": "I 2/m 2/m 2/m",
    "hall_symbol": "-I 2 2",
    "international": "I m m m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "338": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^26",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ibam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 72,
    "choice": "",
    "international_full": "I 2/b 2/a 2/m",
    "hall_symbol": "-I 2 2c",
    "international": "I b a m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "339": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^26",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Imcb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 72,
    "choice": "cab",
    "international_full": "I 2/m 2/c 2/b",
    "hall_symbol": "-I 2a 2",
    "international": "I m c b",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "340": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^26",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Icma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 72,
    "choice": "bca",
    "international_full": "I 2/c 2/m 2/a",
    "hall_symbol": "-I 2b 2b",
    "international": "I c m a",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "341": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^27",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ibca",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 73,
    "choice": "",
    "international_full": "I 2/b 2/c 2/a",
    "hall_symbol": "-I 2b 2c",
    "international": "I b c a",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "342": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^27",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Icab",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 73,
    "choice": "ba-c",
    "international_full": "I 2/c 2/a 2/b",
    "hall_symbol": "-I 2a 2b",
    "international": "I c a b",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "343": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Imma",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "",
    "international_full": "I 2/m 2/m 2/a",
    "hall_symbol": "-I 2b 2",
    "international": "I m m a",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "344": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Immb",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "ba-c",
    "international_full": "I 2/m 2/m 2/b",
    "hall_symbol": "-I 2a 2a",
    "international": "I m m b",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "345": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Ibmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "cab",
    "international_full": "I 2/b 2/m 2/m",
    "hall_symbol": "-I 2c 2c",
    "international": "I b m m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "346": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Icmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "-cba",
    "international_full": "I 2/c 2/m 2/m",
    "hall_symbol": "-I 2 2b",
    "international": "I c m m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "347": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Imcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "bca",
    "international_full": "I 2/m 2/c 2/m",
    "hall_symbol": "-I 2 2a",
    "international": "I m c m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "348": {
    "pointgroup_international": "D2h",
    "schoenflies": "D2h^28",
    "pointgroup_schoenflies": "mmm",
    "international_short": "Imam",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 74,
    "choice": "a-cb",
    "international_full": "I 2/m 2/a 2/m",
    "hall_symbol": "-I 2c 2",
    "international": "I m a m",
    "arithmetic_crystal_class_number": 21,
    "arithmetic_crystal_class_symbol": "mmmI"
  },
  "349": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^1",
    "pointgroup_schoenflies": "4",
    "international_short": "P4",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 75,
    "choice": "",
    "international_full": "P 4",
    "hall_symbol": "P 4",
    "international": "P 4",
    "arithmetic_crystal_class_number": 22,
    "arithmetic_crystal_class_symbol": "4P"
  },
  "350": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^2",
    "pointgroup_schoenflies": "4",
    "international_short": "P4_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 76,
    "choice": "",
    "international_full": "P 4_1",
    "hall_symbol": "P 4w",
    "international": "P 4_1",
    "arithmetic_crystal_class_number": 22,
    "arithmetic_crystal_class_symbol": "4P"
  },
  "351": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^3",
    "pointgroup_schoenflies": "4",
    "international_short": "P4_2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 77,
    "choice": "",
    "international_full": "P 4_2",
    "hall_symbol": "P 4c",
    "international": "P 4_2",
    "arithmetic_crystal_class_number": 22,
    "arithmetic_crystal_class_symbol": "4P"
  },
  "352": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^4",
    "pointgroup_schoenflies": "4",
    "international_short": "P4_3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 78,
    "choice": "",
    "international_full": "P 4_3",
    "hall_symbol": "P 4cw",
    "international": "P 4_3",
    "arithmetic_crystal_class_number": 22,
    "arithmetic_crystal_class_symbol": "4P"
  },
  "353": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^5",
    "pointgroup_schoenflies": "4",
    "international_short": "I4",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 79,
    "choice": "",
    "international_full": "I 4",
    "hall_symbol": "I 4",
    "international": "I 4",
    "arithmetic_crystal_class_number": 23,
    "arithmetic_crystal_class_symbol": "4I"
  },
  "354": {
    "pointgroup_international": "C4",
    "schoenflies": "C4^6",
    "pointgroup_schoenflies": "4",
    "international_short": "I4_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 80,
    "choice": "",
    "international_full": "I 4_1",
    "hall_symbol": "I 4bw",
    "international": "I 4_1",
    "arithmetic_crystal_class_number": 23,
    "arithmetic_crystal_class_symbol": "4I"
  },
  "355": {
    "pointgroup_international": "S4",
    "schoenflies": "S4^1",
    "pointgroup_schoenflies": "-4",
    "international_short": "P-4",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 81,
    "choice": "",
    "international_full": "P -4",
    "hall_symbol": "P -4",
    "international": "P -4",
    "arithmetic_crystal_class_number": 24,
    "arithmetic_crystal_class_symbol": "-4P"
  },
  "356": {
    "pointgroup_international": "S4",
    "schoenflies": "S4^2",
    "pointgroup_schoenflies": "-4",
    "international_short": "I-4",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 82,
    "choice": "",
    "international_full": "I -4",
    "hall_symbol": "I -4",
    "international": "I -4",
    "arithmetic_crystal_class_number": 25,
    "arithmetic_crystal_class_symbol": "-4I"
  },
  "357": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^1",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 83,
    "choice": "",
    "international_full": "P 4/m",
    "hall_symbol": "-P 4",
    "international": "P 4/m",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "358": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^2",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4_2/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 84,
    "choice": "",
    "international_full": "P 4_2/m",
    "hall_symbol": "-P 4c",
    "international": "P 4_2/m",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "359": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^3",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4/n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 85,
    "choice": "1",
    "international_full": "P 4/n",
    "hall_symbol": "P 4ab -1ab",
    "international": "P 4/n",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "360": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^3",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4/n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 85,
    "choice": "2",
    "international_full": "P 4/n",
    "hall_symbol": "-P 4a",
    "international": "P 4/n",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "361": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^4",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4_2/n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 86,
    "choice": "1",
    "international_full": "P 4_2/n",
    "hall_symbol": "P 4n -1n",
    "international": "P 4_2/n",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "362": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^4",
    "pointgroup_schoenflies": "4/m",
    "international_short": "P4_2/n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 86,
    "choice": "2",
    "international_full": "P 4_2/n",
    "hall_symbol": "-P 4bc",
    "international": "P 4_2/n",
    "arithmetic_crystal_class_number": 26,
    "arithmetic_crystal_class_symbol": "4/mP"
  },
  "363": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^5",
    "pointgroup_schoenflies": "4/m",
    "international_short": "I4/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 87,
    "choice": "",
    "international_full": "I 4/m",
    "hall_symbol": "-I 4",
    "international": "I 4/m",
    "arithmetic_crystal_class_number": 27,
    "arithmetic_crystal_class_symbol": "4/mI"
  },
  "364": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^6",
    "pointgroup_schoenflies": "4/m",
    "international_short": "I4_1/a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 88,
    "choice": "1",
    "international_full": "I 4_1/a",
    "hall_symbol": "I 4bw -1bw",
    "international": "I 4_1/a",
    "arithmetic_crystal_class_number": 27,
    "arithmetic_crystal_class_symbol": "4/mI"
  },
  "365": {
    "pointgroup_international": "C4h",
    "schoenflies": "C4h^6",
    "pointgroup_schoenflies": "4/m",
    "international_short": "I4_1/a",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 88,
    "choice": "2",
    "international_full": "I 4_1/a",
    "hall_symbol": "-I 4ad",
    "international": "I 4_1/a",
    "arithmetic_crystal_class_number": 27,
    "arithmetic_crystal_class_symbol": "4/mI"
  },
  "366": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^1",
    "pointgroup_schoenflies": "422",
    "international_short": "P422",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 89,
    "choice": "",
    "international_full": "P 4 2 2",
    "hall_symbol": "P 4 2",
    "international": "P 4 2 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "367": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^2",
    "pointgroup_schoenflies": "422",
    "international_short": "P42_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 90,
    "choice": "",
    "international_full": "P 4 2_1 2",
    "hall_symbol": "P 4ab 2ab",
    "international": "P 4 2_1 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "368": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^3",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_122",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 91,
    "choice": "",
    "international_full": "P 4_1 2 2",
    "hall_symbol": "P 4w 2c",
    "international": "P 4_1 2 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "369": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^4",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_12_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.25],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.75],
      [0.5, 0.5, 0.75],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.25],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 92,
    "choice": "",
    "international_full": "P 4_1 2_1 2",
    "hall_symbol": "P 4abw 2nw",
    "international": "P 4_1 2_1 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "370": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^5",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 93,
    "choice": "",
    "international_full": "P 4_2 2 2",
    "hall_symbol": "P 4c 2",
    "international": "P 4_2 2 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "371": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^6",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_22_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 94,
    "choice": "",
    "international_full": "P 4_2 2_1 2",
    "hall_symbol": "P 4n 2n",
    "international": "P 4_2 2_1 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "372": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^7",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_322",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 95,
    "choice": "",
    "international_full": "P 4_3 2 2",
    "hall_symbol": "P 4cw 2c",
    "international": "P 4_3 2 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "373": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^8",
    "pointgroup_schoenflies": "422",
    "international_short": "P4_32_12",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.75],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.25],
      [0.5, 0.5, 0.25],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.75],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 96,
    "choice": "",
    "international_full": "P 4_3 2_1 2",
    "hall_symbol": "P 4nw 2abw",
    "international": "P 4_3 2_1 2",
    "arithmetic_crystal_class_number": 28,
    "arithmetic_crystal_class_symbol": "422P"
  },
  "374": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^9",
    "pointgroup_schoenflies": "422",
    "international_short": "I422",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 97,
    "choice": "",
    "international_full": "I 4 2 2",
    "hall_symbol": "I 4 2",
    "international": "I 4 2 2",
    "arithmetic_crystal_class_number": 29,
    "arithmetic_crystal_class_symbol": "422I"
  },
  "375": {
    "pointgroup_international": "D4",
    "schoenflies": "D4^10",
    "pointgroup_schoenflies": "422",
    "international_short": "I4_122",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 98,
    "choice": "",
    "international_full": "I 4_1 2 2",
    "hall_symbol": "I 4bw 2bw",
    "international": "I 4_1 2 2",
    "arithmetic_crystal_class_number": 29,
    "arithmetic_crystal_class_symbol": "422I"
  },
  "376": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^1",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 99,
    "choice": "",
    "international_full": "P 4 m m",
    "hall_symbol": "P 4 -2",
    "international": "P 4 m m",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "377": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^2",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4bm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 100,
    "choice": "",
    "international_full": "P 4 b m",
    "hall_symbol": "P 4 -2ab",
    "international": "P 4 b m",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "378": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^3",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4_2cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 101,
    "choice": "",
    "international_full": "P 4_2 c m",
    "hall_symbol": "P 4c -2c",
    "international": "P 4_2 c m",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "379": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^4",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4_2nm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 102,
    "choice": "",
    "international_full": "P 4_2 n m",
    "hall_symbol": "P 4n -2n",
    "international": "P 4_2 n m",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "380": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^5",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 103,
    "choice": "",
    "international_full": "P 4 c c",
    "hall_symbol": "P 4 -2c",
    "international": "P 4 c c",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "381": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^6",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4nc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 104,
    "choice": "",
    "international_full": "P 4 n c",
    "hall_symbol": "P 4 -2n",
    "international": "P 4 n c",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "382": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^7",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4_2mc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 105,
    "choice": "",
    "international_full": "P 4_2 m c",
    "hall_symbol": "P 4c -2",
    "international": "P 4_2 m c",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "383": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^8",
    "pointgroup_schoenflies": "4mm",
    "international_short": "P4_2bc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 106,
    "choice": "",
    "international_full": "P 4_2 b c",
    "hall_symbol": "P 4c -2ab",
    "international": "P 4_2 b c",
    "arithmetic_crystal_class_number": 30,
    "arithmetic_crystal_class_symbol": "4mmP"
  },
  "384": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^9",
    "pointgroup_schoenflies": "4mm",
    "international_short": "I4mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 107,
    "choice": "",
    "international_full": "I 4 m m",
    "hall_symbol": "I 4 -2",
    "international": "I 4 m m",
    "arithmetic_crystal_class_number": 31,
    "arithmetic_crystal_class_symbol": "4mmI"
  },
  "385": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^10",
    "pointgroup_schoenflies": "4mm",
    "international_short": "I4cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 108,
    "choice": "",
    "international_full": "I 4 c m",
    "hall_symbol": "I 4 -2c",
    "international": "I 4 c m",
    "arithmetic_crystal_class_number": 31,
    "arithmetic_crystal_class_symbol": "4mmI"
  },
  "386": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^11",
    "pointgroup_schoenflies": "4mm",
    "international_short": "I4_1md",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 109,
    "choice": "",
    "international_full": "I 4_1 m d",
    "hall_symbol": "I 4bw -2",
    "international": "I 4_1 m d",
    "arithmetic_crystal_class_number": 31,
    "arithmetic_crystal_class_symbol": "4mmI"
  },
  "387": {
    "pointgroup_international": "C4v",
    "schoenflies": "C4v^12",
    "pointgroup_schoenflies": "4mm",
    "international_short": "I4_1cd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 110,
    "choice": "",
    "international_full": "I 4_1 c d",
    "hall_symbol": "I 4bw -2c",
    "international": "I 4_1 c d",
    "arithmetic_crystal_class_number": 31,
    "arithmetic_crystal_class_symbol": "4mmI"
  },
  "388": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^1",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-42m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 111,
    "choice": "",
    "international_full": "P -4 2 m",
    "hall_symbol": "P -4 2",
    "international": "P -4 2 m",
    "arithmetic_crystal_class_number": 32,
    "arithmetic_crystal_class_symbol": "-42mP"
  },
  "389": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^2",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-42c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 112,
    "choice": "",
    "international_full": "P -4 2 c",
    "hall_symbol": "P -4 2c",
    "international": "P -4 2 c",
    "arithmetic_crystal_class_number": 32,
    "arithmetic_crystal_class_symbol": "-42mP"
  },
  "390": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^3",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-42_1m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 113,
    "choice": "",
    "international_full": "P -4 2_1 m",
    "hall_symbol": "P -4 2ab",
    "international": "P -4 2_1 m",
    "arithmetic_crystal_class_number": 32,
    "arithmetic_crystal_class_symbol": "-42mP"
  },
  "391": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^4",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-42_1c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 114,
    "choice": "",
    "international_full": "P -4 2_1 c",
    "hall_symbol": "P -4 2n",
    "international": "P -4 2_1 c",
    "arithmetic_crystal_class_number": 32,
    "arithmetic_crystal_class_symbol": "-42mP"
  },
  "392": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^5",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-4m2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 115,
    "choice": "",
    "international_full": "P -4 m 2",
    "hall_symbol": "P -4 -2",
    "international": "P -4 m 2",
    "arithmetic_crystal_class_number": 33,
    "arithmetic_crystal_class_symbol": "-4m2P"
  },
  "393": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^6",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-4c2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 116,
    "choice": "",
    "international_full": "P -4 c 2",
    "hall_symbol": "P -4 -2c",
    "international": "P -4 c 2",
    "arithmetic_crystal_class_number": 33,
    "arithmetic_crystal_class_symbol": "-4m2P"
  },
  "394": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^7",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-4b2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 117,
    "choice": "",
    "international_full": "P -4 b 2",
    "hall_symbol": "P -4 -2ab",
    "international": "P -4 b 2",
    "arithmetic_crystal_class_number": 33,
    "arithmetic_crystal_class_symbol": "-4m2P"
  },
  "395": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^8",
    "pointgroup_schoenflies": "-42m",
    "international_short": "P-4n2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 118,
    "choice": "",
    "international_full": "P -4 n 2",
    "hall_symbol": "P -4 -2n",
    "international": "P -4 n 2",
    "arithmetic_crystal_class_number": 33,
    "arithmetic_crystal_class_symbol": "-4m2P"
  },
  "396": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^9",
    "pointgroup_schoenflies": "-42m",
    "international_short": "I-4m2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 119,
    "choice": "",
    "international_full": "I -4 m 2",
    "hall_symbol": "I -4 -2",
    "international": "I -4 m 2",
    "arithmetic_crystal_class_number": 34,
    "arithmetic_crystal_class_symbol": "-4m2I"
  },
  "397": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^10",
    "pointgroup_schoenflies": "-42m",
    "international_short": "I-4c2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 120,
    "choice": "",
    "international_full": "I -4 c 2",
    "hall_symbol": "I -4 -2c",
    "international": "I -4 c 2",
    "arithmetic_crystal_class_number": 34,
    "arithmetic_crystal_class_symbol": "-4m2I"
  },
  "398": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^11",
    "pointgroup_schoenflies": "-42m",
    "international_short": "I-42m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 121,
    "choice": "",
    "international_full": "I -4 2 m",
    "hall_symbol": "I -4 2",
    "international": "I -4 2 m",
    "arithmetic_crystal_class_number": 35,
    "arithmetic_crystal_class_symbol": "-42mI"
  },
  "399": {
    "pointgroup_international": "D2d",
    "schoenflies": "D2d^12",
    "pointgroup_schoenflies": "-42m",
    "international_short": "I-42d",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.0, 0.5, 0.25],
      [0.0, 0.5, 0.25],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.5, 0.0, 0.75],
      [0.5, 0.0, 0.75],
      [0.5, 0.0, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 122,
    "choice": "",
    "international_full": "I -4 2 d",
    "hall_symbol": "I -4 2bw",
    "international": "I -4 2 d",
    "arithmetic_crystal_class_number": 35,
    "arithmetic_crystal_class_symbol": "-42mI"
  },
  "400": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^1",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/mmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 123,
    "choice": "",
    "international_full": "P 4/m 2/m 2/m",
    "hall_symbol": "-P 4 2",
    "international": "P 4/m m m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "401": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^2",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/mcc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 124,
    "choice": "",
    "international_full": "P 4/m 2/c 2/c",
    "hall_symbol": "-P 4 2c",
    "international": "P 4/m c c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "402": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^3",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nbm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 125,
    "choice": "1",
    "international_full": "P 4/n 2/b 2/m",
    "hall_symbol": "P 4 2 -1ab",
    "international": "P 4/n b m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "403": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^3",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nbm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 125,
    "choice": "2",
    "international_full": "P 4/n 2/b 2/m",
    "hall_symbol": "-P 4a 2b",
    "international": "P 4/n b m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "404": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^4",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nnc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 126,
    "choice": "1",
    "international_full": "P 4/n 2/n 2/c",
    "hall_symbol": "P 4 2 -1n",
    "international": "P 4/n n c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "405": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^4",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nnc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 126,
    "choice": "2",
    "international_full": "P 4/n 2/n 2/c",
    "hall_symbol": "-P 4a 2bc",
    "international": "P 4/n n c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "406": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^5",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/mbm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 127,
    "choice": "",
    "international_full": "P 4/m 2_1/b m",
    "hall_symbol": "-P 4 2ab",
    "international": "P 4/m b m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "407": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^6",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/mnc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 128,
    "choice": "",
    "international_full": "P 4/m 2_1/n c",
    "hall_symbol": "-P 4 2n",
    "international": "P 4/m n c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "408": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^7",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 129,
    "choice": "1",
    "international_full": "P 4/n 2_1/m m",
    "hall_symbol": "P 4ab 2ab -1ab",
    "international": "P 4/n m m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "409": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^7",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/nmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 129,
    "choice": "2",
    "international_full": "P 4/n 2_1/m m",
    "hall_symbol": "-P 4a 2a",
    "international": "P 4/n m m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "410": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^8",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/ncc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 130,
    "choice": "1",
    "international_full": "P 4/n 2_1/c c",
    "hall_symbol": "P 4ab 2n -1ab",
    "international": "P 4/n c c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "411": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^8",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4/ncc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 130,
    "choice": "2",
    "international_full": "P 4/n 2_1/c c",
    "hall_symbol": "-P 4a 2ac",
    "international": "P 4/n c c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "412": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^9",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/mmc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 131,
    "choice": "",
    "international_full": "P 4_2/m 2/m 2/c",
    "hall_symbol": "-P 4c 2",
    "international": "P 4_2/m m c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "413": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^10",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/mcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 132,
    "choice": "",
    "international_full": "P 4_2/m 2/c 2/m",
    "hall_symbol": "-P 4c 2c",
    "international": "P 4_2/m c m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "414": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^11",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nbc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 133,
    "choice": "1",
    "international_full": "P 4_2/n 2/b 2/c",
    "hall_symbol": "P 4n 2c -1n",
    "international": "P 4_2/n b c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "415": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^11",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nbc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 133,
    "choice": "2",
    "international_full": "P 4_2/n 2/b 2/c",
    "hall_symbol": "-P 4ac 2b",
    "international": "P 4_2/n b c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "416": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^12",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 134,
    "choice": "1",
    "international_full": "P 4_2/n 2/n 2/m",
    "hall_symbol": "P 4n 2 -1n",
    "international": "P 4_2/n n m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "417": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^12",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 134,
    "choice": "2",
    "international_full": "P 4_2/n 2/n 2/m",
    "hall_symbol": "-P 4ac 2bc",
    "international": "P 4_2/n n m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "418": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^13",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/mbc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 135,
    "choice": "",
    "international_full": "P 4_2/m 2_1/b 2/c",
    "hall_symbol": "-P 4c 2ab",
    "international": "P 4_2/m b c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "419": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^14",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/mnm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 136,
    "choice": "",
    "international_full": "P 4_2/m 2_1/n 2/m",
    "hall_symbol": "-P 4n 2n",
    "international": "P 4_2/m n m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "420": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^15",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nmc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 137,
    "choice": "1",
    "international_full": "P 4_2/n 2_1/m 2/c",
    "hall_symbol": "P 4n 2n -1n",
    "international": "P 4_2/n m c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "421": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^15",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/nmc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 137,
    "choice": "2",
    "international_full": "P 4_2/n 2_1/m 2/c",
    "hall_symbol": "-P 4ac 2a",
    "international": "P 4_2/n m c",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "422": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^16",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/ncm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 138,
    "choice": "1",
    "international_full": "P 4_2/n 2_1/c 2/m",
    "hall_symbol": "P 4n 2ab -1n",
    "international": "P 4_2/n c m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "423": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^16",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "P4_2/ncm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 138,
    "choice": "2",
    "international_full": "P 4_2/n 2_1/c 2/m",
    "hall_symbol": "-P 4ac 2ac",
    "international": "P 4_2/n c m",
    "arithmetic_crystal_class_number": 36,
    "arithmetic_crystal_class_symbol": "4/mmmP"
  },
  "424": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^17",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4/mmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 139,
    "choice": "",
    "international_full": "I 4/m 2/m 2/m",
    "hall_symbol": "-I 4 2",
    "international": "I 4/m m m",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "425": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^18",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4/mcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 140,
    "choice": "",
    "international_full": "I 4/m 2/c 2/m",
    "hall_symbol": "-I 4 2c",
    "international": "I 4/m c m",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "426": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^19",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4_1/amd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 141,
    "choice": "1",
    "international_full": "I 4_1/a 2/m 2/d",
    "hall_symbol": "I 4bw 2bw -1bw",
    "international": "I 4_1/a m d",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "427": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^19",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4_1/amd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 141,
    "choice": "2",
    "international_full": "I 4_1/a 2/m 2/d",
    "hall_symbol": "-I 4bd 2",
    "international": "I 4_1/a m d",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "428": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^20",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4_1/acd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.5, 0.0, 0.25],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.25],
      [0.0, 0.5, 0.75],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.75],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 142,
    "choice": "1",
    "international_full": "I 4_1/a 2/c 2/d",
    "hall_symbol": "I 4bw 2aw -1bw",
    "international": "I 4_1/a c d",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "429": {
    "pointgroup_international": "D4h",
    "schoenflies": "D4h^20",
    "pointgroup_schoenflies": "4/mmm",
    "international_short": "I4_1/acd",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.75, 0.25, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 142,
    "choice": "2",
    "international_full": "I 4_1/a 2/c 2/d",
    "hall_symbol": "-I 4bd 2c",
    "international": "I 4_1/a c d",
    "arithmetic_crystal_class_number": 37,
    "arithmetic_crystal_class_symbol": "4/mmmI"
  },
  "430": {
    "pointgroup_international": "C3",
    "schoenflies": "C3^1",
    "pointgroup_schoenflies": "3",
    "international_short": "P3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 143,
    "choice": "",
    "international_full": "P 3",
    "hall_symbol": "P 3",
    "international": "P 3",
    "arithmetic_crystal_class_number": 38,
    "arithmetic_crystal_class_symbol": "3P"
  },
  "431": {
    "pointgroup_international": "C3",
    "schoenflies": "C3^2",
    "pointgroup_schoenflies": "3",
    "international_short": "P3_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 144,
    "choice": "",
    "international_full": "P 3_1",
    "hall_symbol": "P 31",
    "international": "P 3_1",
    "arithmetic_crystal_class_number": 38,
    "arithmetic_crystal_class_symbol": "3P"
  },
  "432": {
    "pointgroup_international": "C3",
    "schoenflies": "C3^3",
    "pointgroup_schoenflies": "3",
    "international_short": "P3_2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 145,
    "choice": "",
    "international_full": "P 3_2",
    "hall_symbol": "P 32",
    "international": "P 3_2",
    "arithmetic_crystal_class_number": 38,
    "arithmetic_crystal_class_symbol": "3P"
  },
  "433": {
    "pointgroup_international": "C3",
    "schoenflies": "C3^4",
    "pointgroup_schoenflies": "3",
    "international_short": "R3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ]
    ],
    "number": 146,
    "choice": "H",
    "international_full": "R 3",
    "hall_symbol": "R 3",
    "international": "R 3",
    "arithmetic_crystal_class_number": 39,
    "arithmetic_crystal_class_symbol": "3R"
  },
  "434": {
    "pointgroup_international": "C3",
    "schoenflies": "C3^4",
    "pointgroup_schoenflies": "3",
    "international_short": "R3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 146,
    "choice": "R",
    "international_full": "R 3",
    "hall_symbol": "P 3*",
    "international": "R 3",
    "arithmetic_crystal_class_number": 39,
    "arithmetic_crystal_class_symbol": "3R"
  },
  "435": {
    "pointgroup_international": "C3i",
    "schoenflies": "C3i^1",
    "pointgroup_schoenflies": "-3",
    "international_short": "P-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 147,
    "choice": "",
    "international_full": "P -3",
    "hall_symbol": "-P 3",
    "international": "P -3",
    "arithmetic_crystal_class_number": 40,
    "arithmetic_crystal_class_symbol": "-3P"
  },
  "436": {
    "pointgroup_international": "C3i",
    "schoenflies": "C3i^2",
    "pointgroup_schoenflies": "-3",
    "international_short": "R-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ]
    ],
    "number": 148,
    "choice": "H",
    "international_full": "R -3",
    "hall_symbol": "-R 3",
    "international": "R -3",
    "arithmetic_crystal_class_number": 41,
    "arithmetic_crystal_class_symbol": "-3R"
  },
  "437": {
    "pointgroup_international": "C3i",
    "schoenflies": "C3i^2",
    "pointgroup_schoenflies": "-3",
    "international_short": "R-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 148,
    "choice": "R",
    "international_full": "R -3",
    "hall_symbol": "-P 3*",
    "international": "R -3",
    "arithmetic_crystal_class_number": 41,
    "arithmetic_crystal_class_symbol": "-3R"
  },
  "438": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^1",
    "pointgroup_schoenflies": "32",
    "international_short": "P312",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 149,
    "choice": "",
    "international_full": "P 3 1 2",
    "hall_symbol": "P 3 2",
    "international": "P 3 1 2",
    "arithmetic_crystal_class_number": 42,
    "arithmetic_crystal_class_symbol": "312P"
  },
  "439": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^2",
    "pointgroup_schoenflies": "32",
    "international_short": "P321",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 150,
    "choice": "",
    "international_full": "P 3 2 1",
    "hall_symbol": "P 3 2\"",
    "international": "P 3 2 1",
    "arithmetic_crystal_class_number": 43,
    "arithmetic_crystal_class_symbol": "321P"
  },
  "440": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^3",
    "pointgroup_schoenflies": "32",
    "international_short": "P3_112",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 151,
    "choice": "",
    "international_full": "P 3_1 1 2",
    "hall_symbol": "P 31 2c (0 0 1)",
    "international": "P 3_1 1 2",
    "arithmetic_crystal_class_number": 42,
    "arithmetic_crystal_class_symbol": "312P"
  },
  "441": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^4",
    "pointgroup_schoenflies": "32",
    "international_short": "P3_121",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 152,
    "choice": "",
    "international_full": "P 3_1 2 1",
    "hall_symbol": "P 31 2\"",
    "international": "P 3_1 2 1",
    "arithmetic_crystal_class_number": 43,
    "arithmetic_crystal_class_symbol": "321P"
  },
  "442": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^5",
    "pointgroup_schoenflies": "32",
    "international_short": "P3_212",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 153,
    "choice": "",
    "international_full": "P 3_2 1 2",
    "hall_symbol": "P 32 2c (0 0 -1)",
    "international": "P 3_2 1 2",
    "arithmetic_crystal_class_number": 42,
    "arithmetic_crystal_class_symbol": "312P"
  },
  "443": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^6",
    "pointgroup_schoenflies": "32",
    "international_short": "P3_221",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 154,
    "choice": "",
    "international_full": "P 3_2 2 1",
    "hall_symbol": "P 32 2\"",
    "international": "P 3_2 2 1",
    "arithmetic_crystal_class_number": 43,
    "arithmetic_crystal_class_symbol": "321P"
  },
  "444": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^7",
    "pointgroup_schoenflies": "32",
    "international_short": "R32",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 155,
    "choice": "H",
    "international_full": "R 3 2",
    "hall_symbol": "R 3 2\"",
    "international": "R 3 2",
    "arithmetic_crystal_class_number": 44,
    "arithmetic_crystal_class_symbol": "32R"
  },
  "445": {
    "pointgroup_international": "D3",
    "schoenflies": "D3^7",
    "pointgroup_schoenflies": "32",
    "international_short": "R32",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ]
    ],
    "number": 155,
    "choice": "R",
    "international_full": "R 3 2",
    "hall_symbol": "P 3* 2",
    "international": "R 3 2",
    "arithmetic_crystal_class_number": 44,
    "arithmetic_crystal_class_symbol": "32R"
  },
  "446": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^1",
    "pointgroup_schoenflies": "3m",
    "international_short": "P3m1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 156,
    "choice": "",
    "international_full": "P 3 m 1",
    "hall_symbol": "P 3 -2\"",
    "international": "P 3 m 1",
    "arithmetic_crystal_class_number": 45,
    "arithmetic_crystal_class_symbol": "3m1P"
  },
  "447": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^2",
    "pointgroup_schoenflies": "3m",
    "international_short": "P31m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 157,
    "choice": "",
    "international_full": "P 3 1 m",
    "hall_symbol": "P 3 -2",
    "international": "P 3 1 m",
    "arithmetic_crystal_class_number": 46,
    "arithmetic_crystal_class_symbol": "31mP"
  },
  "448": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^3",
    "pointgroup_schoenflies": "3m",
    "international_short": "P3c1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 158,
    "choice": "",
    "international_full": "P 3 c 1",
    "hall_symbol": "P 3 -2\"c",
    "international": "P 3 c 1",
    "arithmetic_crystal_class_number": 45,
    "arithmetic_crystal_class_symbol": "3m1P"
  },
  "449": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^4",
    "pointgroup_schoenflies": "3m",
    "international_short": "P31c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 159,
    "choice": "",
    "international_full": "P 3 1 c",
    "hall_symbol": "P 3 -2c",
    "international": "P 3 1 c",
    "arithmetic_crystal_class_number": 46,
    "arithmetic_crystal_class_symbol": "31mP"
  },
  "450": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^5",
    "pointgroup_schoenflies": "3m",
    "international_short": "R3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 160,
    "choice": "H",
    "international_full": "R 3 m",
    "hall_symbol": "R 3 -2\"",
    "international": "R 3 m",
    "arithmetic_crystal_class_number": 47,
    "arithmetic_crystal_class_symbol": "3mR"
  },
  "451": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^5",
    "pointgroup_schoenflies": "3m",
    "international_short": "R3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ]
    ],
    "number": 160,
    "choice": "R",
    "international_full": "R 3 m",
    "hall_symbol": "P 3* -2",
    "international": "R 3 m",
    "arithmetic_crystal_class_number": 47,
    "arithmetic_crystal_class_symbol": "3mR"
  },
  "452": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^6",
    "pointgroup_schoenflies": "3m",
    "international_short": "R3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 161,
    "choice": "H",
    "international_full": "R 3 c",
    "hall_symbol": "R 3 -2\"c",
    "international": "R 3 c",
    "arithmetic_crystal_class_number": 47,
    "arithmetic_crystal_class_symbol": "3mR"
  },
  "453": {
    "pointgroup_international": "C3v",
    "schoenflies": "C3v^6",
    "pointgroup_schoenflies": "3m",
    "international_short": "R3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ]
    ],
    "number": 161,
    "choice": "R",
    "international_full": "R 3 c",
    "hall_symbol": "P 3* -2n",
    "international": "R 3 c",
    "arithmetic_crystal_class_number": 47,
    "arithmetic_crystal_class_symbol": "3mR"
  },
  "454": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^1",
    "pointgroup_schoenflies": "-3m",
    "international_short": "P-31m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 162,
    "choice": "",
    "international_full": "P -3 1 2/m",
    "hall_symbol": "-P 3 2",
    "international": "P -3 1 m",
    "arithmetic_crystal_class_number": 48,
    "arithmetic_crystal_class_symbol": "-31mP"
  },
  "455": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^2",
    "pointgroup_schoenflies": "-3m",
    "international_short": "P-31c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 163,
    "choice": "",
    "international_full": "P -3 1 2/c",
    "hall_symbol": "-P 3 2c",
    "international": "P -3 1 c",
    "arithmetic_crystal_class_number": 48,
    "arithmetic_crystal_class_symbol": "-31mP"
  },
  "456": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^3",
    "pointgroup_schoenflies": "-3m",
    "international_short": "P-3m1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 164,
    "choice": "",
    "international_full": "P -3 2/m 1",
    "hall_symbol": "-P 3 2\"",
    "international": "P -3 m 1",
    "arithmetic_crystal_class_number": 49,
    "arithmetic_crystal_class_symbol": "-3m1P"
  },
  "457": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^4",
    "pointgroup_schoenflies": "-3m",
    "international_short": "P-3c1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 165,
    "choice": "",
    "international_full": "P -3 2/c 1",
    "hall_symbol": "-P 3 2\"c",
    "international": "P -3 c 1",
    "arithmetic_crystal_class_number": 49,
    "arithmetic_crystal_class_symbol": "-3m1P"
  },
  "458": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^5",
    "pointgroup_schoenflies": "-3m",
    "international_short": "R-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 166,
    "choice": "H",
    "international_full": "R -3 2/m",
    "hall_symbol": "-R 3 2\"",
    "international": "R -3 m",
    "arithmetic_crystal_class_number": 50,
    "arithmetic_crystal_class_symbol": "-3mR"
  },
  "459": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^5",
    "pointgroup_schoenflies": "-3m",
    "international_short": "R-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ]
    ],
    "number": 166,
    "choice": "R",
    "international_full": "R -3 2/m",
    "hall_symbol": "-P 3* 2",
    "international": "R -3 m",
    "arithmetic_crystal_class_number": 50,
    "arithmetic_crystal_class_symbol": "-3mR"
  },
  "460": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^6",
    "pointgroup_schoenflies": "-3m",
    "international_short": "R-3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.3333333333333333],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.6666666666666666, 0.3333333333333333, 0.8333333333333334],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.6666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666],
      [0.3333333333333333, 0.6666666666666666, 0.16666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 167,
    "choice": "H",
    "international_full": "R -3 2/c",
    "hall_symbol": "-R 3 2\"c",
    "international": "R -3 c",
    "arithmetic_crystal_class_number": 50,
    "arithmetic_crystal_class_symbol": "-3mR"
  },
  "461": {
    "pointgroup_international": "D3d",
    "schoenflies": "D3d^6",
    "pointgroup_schoenflies": "-3m",
    "international_short": "R-3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ]
    ],
    "number": 167,
    "choice": "R",
    "international_full": "R -3 2/c",
    "hall_symbol": "-P 3* 2n",
    "international": "R -3 c",
    "arithmetic_crystal_class_number": 50,
    "arithmetic_crystal_class_symbol": "-3mR"
  },
  "462": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^1",
    "pointgroup_schoenflies": "6",
    "international_short": "P6",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 168,
    "choice": "",
    "international_full": "P 6",
    "hall_symbol": "P 6",
    "international": "P 6",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "463": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^2",
    "pointgroup_schoenflies": "6",
    "international_short": "P6_1",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.16666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.8333333333333334]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 169,
    "choice": "",
    "international_full": "P 6_1",
    "hall_symbol": "P 61",
    "international": "P 6_1",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "464": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^3",
    "pointgroup_schoenflies": "6",
    "international_short": "P6_5",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.8333333333333334],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.16666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 170,
    "choice": "",
    "international_full": "P 6_5",
    "hall_symbol": "P 65",
    "international": "P 6_5",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "465": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^4",
    "pointgroup_schoenflies": "6",
    "international_short": "P6_2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 171,
    "choice": "",
    "international_full": "P 6_2",
    "hall_symbol": "P 62",
    "international": "P 6_2",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "466": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^5",
    "pointgroup_schoenflies": "6",
    "international_short": "P6_4",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 172,
    "choice": "",
    "international_full": "P 6_4",
    "hall_symbol": "P 64",
    "international": "P 6_4",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "467": {
    "pointgroup_international": "C6",
    "schoenflies": "C6^6",
    "pointgroup_schoenflies": "6",
    "international_short": "P6_3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 173,
    "choice": "",
    "international_full": "P 6_3",
    "hall_symbol": "P 6c",
    "international": "P 6_3",
    "arithmetic_crystal_class_number": 51,
    "arithmetic_crystal_class_symbol": "6P"
  },
  "468": {
    "pointgroup_international": "C3h",
    "schoenflies": "C3h^1",
    "pointgroup_schoenflies": "-6",
    "international_short": "P-6",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 174,
    "choice": "",
    "international_full": "P -6",
    "hall_symbol": "P -6",
    "international": "P -6",
    "arithmetic_crystal_class_number": 52,
    "arithmetic_crystal_class_symbol": "-6P"
  },
  "469": {
    "pointgroup_international": "C6h",
    "schoenflies": "C6h^1",
    "pointgroup_schoenflies": "6/m",
    "international_short": "P6/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 175,
    "choice": "",
    "international_full": "P 6/m",
    "hall_symbol": "-P 6",
    "international": "P 6/m",
    "arithmetic_crystal_class_number": 53,
    "arithmetic_crystal_class_symbol": "6/mP"
  },
  "470": {
    "pointgroup_international": "C6h",
    "schoenflies": "C6h^2",
    "pointgroup_schoenflies": "6/m",
    "international_short": "P6_3/m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 176,
    "choice": "",
    "international_full": "P 6_3/m",
    "hall_symbol": "-P 6c",
    "international": "P 6_3/m",
    "arithmetic_crystal_class_number": 53,
    "arithmetic_crystal_class_symbol": "6/mP"
  },
  "471": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^1",
    "pointgroup_schoenflies": "622",
    "international_short": "P622",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 177,
    "choice": "",
    "international_full": "P 6 2 2",
    "hall_symbol": "P 6 2",
    "international": "P 6 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "472": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^2",
    "pointgroup_schoenflies": "622",
    "international_short": "P6_122",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.16666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.8333333333333334],
      [0.0, 0.0, 0.8333333333333334],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.16666666666666666],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 178,
    "choice": "",
    "international_full": "P 6_1 2 2",
    "hall_symbol": "P 61 2 (0 0 -1)",
    "international": "P 6_1 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "473": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^3",
    "pointgroup_schoenflies": "622",
    "international_short": "P6_522",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.8333333333333334],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.16666666666666666],
      [0.0, 0.0, 0.16666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.8333333333333334],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 179,
    "choice": "",
    "international_full": "P 6_5 2 2",
    "hall_symbol": "P 65 2 (0 0 1)",
    "international": "P 6_5 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "474": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^4",
    "pointgroup_schoenflies": "622",
    "international_short": "P6_222",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 180,
    "choice": "",
    "international_full": "P 6_2 2 2",
    "hall_symbol": "P 62 2c (0 0 1)",
    "international": "P 6_2 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "475": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^5",
    "pointgroup_schoenflies": "622",
    "international_short": "P6_422",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.3333333333333333],
      [0.0, 0.0, 0.6666666666666666],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 181,
    "choice": "",
    "international_full": "P 6_4 2 2",
    "hall_symbol": "P 64 2c (0 0 -1)",
    "international": "P 6_4 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "476": {
    "pointgroup_international": "D6",
    "schoenflies": "D6^6",
    "pointgroup_schoenflies": "622",
    "international_short": "P6_322",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 182,
    "choice": "",
    "international_full": "P 6_3 2 2",
    "hall_symbol": "P 6c 2c",
    "international": "P 6_3 2 2",
    "arithmetic_crystal_class_number": 54,
    "arithmetic_crystal_class_symbol": "622P"
  },
  "477": {
    "pointgroup_international": "C6v",
    "schoenflies": "C6v^1",
    "pointgroup_schoenflies": "6mm",
    "international_short": "P6mm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 183,
    "choice": "",
    "international_full": "P 6 m m",
    "hall_symbol": "P 6 -2",
    "international": "P 6 m m",
    "arithmetic_crystal_class_number": 55,
    "arithmetic_crystal_class_symbol": "6mmP"
  },
  "478": {
    "pointgroup_international": "C6v",
    "schoenflies": "C6v^2",
    "pointgroup_schoenflies": "6mm",
    "international_short": "P6cc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 184,
    "choice": "",
    "international_full": "P 6 c c",
    "hall_symbol": "P 6 -2c",
    "international": "P 6 c c",
    "arithmetic_crystal_class_number": 55,
    "arithmetic_crystal_class_symbol": "6mmP"
  },
  "479": {
    "pointgroup_international": "C6v",
    "schoenflies": "C6v^3",
    "pointgroup_schoenflies": "6mm",
    "international_short": "P6_3cm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 185,
    "choice": "",
    "international_full": "P 6_3 c m",
    "hall_symbol": "P 6c -2",
    "international": "P 6_3 c m",
    "arithmetic_crystal_class_number": 55,
    "arithmetic_crystal_class_symbol": "6mmP"
  },
  "480": {
    "pointgroup_international": "C6v",
    "schoenflies": "C6v^4",
    "pointgroup_schoenflies": "6mm",
    "international_short": "P6_3mc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 186,
    "choice": "",
    "international_full": "P 6_3 m c",
    "hall_symbol": "P 6c -2c",
    "international": "P 6_3 m c",
    "arithmetic_crystal_class_number": 55,
    "arithmetic_crystal_class_symbol": "6mmP"
  },
  "481": {
    "pointgroup_international": "D3h",
    "schoenflies": "D3h^1",
    "pointgroup_schoenflies": "-6m2",
    "international_short": "P-6m2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 187,
    "choice": "",
    "international_full": "P -6 m 2",
    "hall_symbol": "P -6 2",
    "international": "P -6 m 2",
    "arithmetic_crystal_class_number": 56,
    "arithmetic_crystal_class_symbol": "-62mP"
  },
  "482": {
    "pointgroup_international": "D3h",
    "schoenflies": "D3h^2",
    "pointgroup_schoenflies": "-6m2",
    "international_short": "P-6c2",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 188,
    "choice": "",
    "international_full": "P -6 c 2",
    "hall_symbol": "P -6c 2",
    "international": "P -6 c 2",
    "arithmetic_crystal_class_number": 56,
    "arithmetic_crystal_class_symbol": "-62mP"
  },
  "483": {
    "pointgroup_international": "D3h",
    "schoenflies": "D3h^3",
    "pointgroup_schoenflies": "-6m2",
    "international_short": "P-62m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 189,
    "choice": "",
    "international_full": "P -6 2 m",
    "hall_symbol": "P -6 -2",
    "international": "P -6 2 m",
    "arithmetic_crystal_class_number": 57,
    "arithmetic_crystal_class_symbol": "-6m2P"
  },
  "484": {
    "pointgroup_international": "D3h",
    "schoenflies": "D3h^4",
    "pointgroup_schoenflies": "-6m2",
    "international_short": "P-62c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ]
    ],
    "number": 190,
    "choice": "",
    "international_full": "P -6 2 c",
    "hall_symbol": "P -6c -2c",
    "international": "P -6 2 c",
    "arithmetic_crystal_class_number": 57,
    "arithmetic_crystal_class_symbol": "-6m2P"
  },
  "485": {
    "pointgroup_international": "D6h",
    "schoenflies": "D6h^1",
    "pointgroup_schoenflies": "6/mmm",
    "international_short": "P6/mmm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 191,
    "choice": "",
    "international_full": "P 6/m 2/m 2/m",
    "hall_symbol": "-P 6 2",
    "international": "P 6/m m m",
    "arithmetic_crystal_class_number": 58,
    "arithmetic_crystal_class_symbol": "6/mmm"
  },
  "486": {
    "pointgroup_international": "D6h",
    "schoenflies": "D6h^2",
    "pointgroup_schoenflies": "6/mmm",
    "international_short": "P6/mcc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 192,
    "choice": "",
    "international_full": "P 6/m 2/c 2/c",
    "hall_symbol": "-P 6 2c",
    "international": "P 6/m c c",
    "arithmetic_crystal_class_number": 58,
    "arithmetic_crystal_class_symbol": "6/mmm"
  },
  "487": {
    "pointgroup_international": "D6h",
    "schoenflies": "D6h^3",
    "pointgroup_schoenflies": "6/mmm",
    "international_short": "P6_3/mcm",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 193,
    "choice": "",
    "international_full": "P 6_3/m 2/c 2/m",
    "hall_symbol": "-P 6c 2",
    "international": "P 6_3/m c m",
    "arithmetic_crystal_class_number": 58,
    "arithmetic_crystal_class_symbol": "6/mmm"
  },
  "488": {
    "pointgroup_international": "D6h",
    "schoenflies": "D6h^4",
    "pointgroup_schoenflies": "6/mmm",
    "international_short": "P6_3/mmc",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [1, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [-1, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, -1, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 1, 0],
        [0, 1, 0],
        [0, 0, 1]
      ]
    ],
    "number": 194,
    "choice": "",
    "international_full": "P 6_3/m 2/m 2/c",
    "hall_symbol": "-P 6c 2c",
    "international": "P 6_3/m m c",
    "arithmetic_crystal_class_number": 58,
    "arithmetic_crystal_class_symbol": "6/mmm"
  },
  "489": {
    "pointgroup_international": "T",
    "schoenflies": "T^1",
    "pointgroup_schoenflies": "23",
    "international_short": "P23",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 195,
    "choice": "",
    "international_full": "P 2 3",
    "hall_symbol": "P 2 2 3",
    "international": "P 2 3",
    "arithmetic_crystal_class_number": 59,
    "arithmetic_crystal_class_symbol": "23P"
  },
  "490": {
    "pointgroup_international": "T",
    "schoenflies": "T^2",
    "pointgroup_schoenflies": "23",
    "international_short": "F23",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 196,
    "choice": "",
    "international_full": "F 2 3",
    "hall_symbol": "F 2 2 3",
    "international": "F 2 3",
    "arithmetic_crystal_class_number": 60,
    "arithmetic_crystal_class_symbol": "23F"
  },
  "491": {
    "pointgroup_international": "T",
    "schoenflies": "T^3",
    "pointgroup_schoenflies": "23",
    "international_short": "I23",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 197,
    "choice": "",
    "international_full": "I 2 3",
    "hall_symbol": "I 2 2 3",
    "international": "I 2 3",
    "arithmetic_crystal_class_number": 61,
    "arithmetic_crystal_class_symbol": "23I"
  },
  "492": {
    "pointgroup_international": "T",
    "schoenflies": "T^4",
    "pointgroup_schoenflies": "23",
    "international_short": "P2_13",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 198,
    "choice": "",
    "international_full": "P 2_1 3",
    "hall_symbol": "P 2ac 2ab 3",
    "international": "P 2_1 3",
    "arithmetic_crystal_class_number": 59,
    "arithmetic_crystal_class_symbol": "23P"
  },
  "493": {
    "pointgroup_international": "T",
    "schoenflies": "T^5",
    "pointgroup_schoenflies": "23",
    "international_short": "I2_13",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ]
    ],
    "number": 199,
    "choice": "",
    "international_full": "I 2_1 3",
    "hall_symbol": "I 2b 2c 3",
    "international": "I 2_1 3",
    "arithmetic_crystal_class_number": 61,
    "arithmetic_crystal_class_symbol": "23I"
  },
  "494": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^1",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Pm-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 200,
    "choice": "",
    "international_full": "P 2/m -3",
    "hall_symbol": "-P 2 2 3",
    "international": "P m -3",
    "arithmetic_crystal_class_number": 62,
    "arithmetic_crystal_class_symbol": "m-3P"
  },
  "495": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^2",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Pn-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 201,
    "choice": "1",
    "international_full": "P 2/n -3",
    "hall_symbol": "P 2 2 3 -1n",
    "international": "P n -3",
    "arithmetic_crystal_class_number": 62,
    "arithmetic_crystal_class_symbol": "m-3P"
  },
  "496": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^2",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Pn-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 201,
    "choice": "2",
    "international_full": "P 2/n -3",
    "hall_symbol": "-P 2ab 2bc 3",
    "international": "P n -3",
    "arithmetic_crystal_class_number": 62,
    "arithmetic_crystal_class_symbol": "m-3P"
  },
  "497": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^3",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Fm-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 202,
    "choice": "",
    "international_full": "F 2/m -3",
    "hall_symbol": "-F 2 2 3",
    "international": "F m -3",
    "arithmetic_crystal_class_number": 63,
    "arithmetic_crystal_class_symbol": "m-3F"
  },
  "498": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^4",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Fd-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 203,
    "choice": "1",
    "international_full": "F 2/d -3",
    "hall_symbol": "F 2 2 3 -1d",
    "international": "F d -3",
    "arithmetic_crystal_class_number": 63,
    "arithmetic_crystal_class_symbol": "m-3F"
  },
  "499": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^4",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Fd-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 203,
    "choice": "2",
    "international_full": "F 2/d -3",
    "hall_symbol": "-F 2uv 2vw 3",
    "international": "F d -3",
    "arithmetic_crystal_class_number": 63,
    "arithmetic_crystal_class_symbol": "m-3F"
  },
  "500": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^5",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Im-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 204,
    "choice": "",
    "international_full": "I 2/m -3",
    "hall_symbol": "-I 2 2 3",
    "international": "I m -3",
    "arithmetic_crystal_class_number": 64,
    "arithmetic_crystal_class_symbol": "m-3I"
  },
  "501": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^6",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Pa-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 205,
    "choice": "",
    "international_full": "P 2_1/a -3",
    "hall_symbol": "-P 2ac 2ab 3",
    "international": "P a -3",
    "arithmetic_crystal_class_number": 62,
    "arithmetic_crystal_class_symbol": "m-3P"
  },
  "502": {
    "pointgroup_international": "Th",
    "schoenflies": "Th^7",
    "pointgroup_schoenflies": "m-3",
    "international_short": "Ia-3",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ]
    ],
    "number": 206,
    "choice": "",
    "international_full": "I 2_1/a -3",
    "hall_symbol": "-I 2b 2c 3",
    "international": "I a -3",
    "arithmetic_crystal_class_number": 64,
    "arithmetic_crystal_class_symbol": "m-3I"
  },
  "503": {
    "pointgroup_international": "O",
    "schoenflies": "O^1",
    "pointgroup_schoenflies": "432",
    "international_short": "P432",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 207,
    "choice": "",
    "international_full": "P 4 3 2",
    "hall_symbol": "P 4 2 3",
    "international": "P 4 3 2",
    "arithmetic_crystal_class_number": 65,
    "arithmetic_crystal_class_symbol": "432P"
  },
  "504": {
    "pointgroup_international": "O",
    "schoenflies": "O^2",
    "pointgroup_schoenflies": "432",
    "international_short": "P4_232",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 208,
    "choice": "",
    "international_full": "P 4_2 3 2",
    "hall_symbol": "P 4n 2 3",
    "international": "P 4_2 3 2",
    "arithmetic_crystal_class_number": 65,
    "arithmetic_crystal_class_symbol": "432P"
  },
  "505": {
    "pointgroup_international": "O",
    "schoenflies": "O^3",
    "pointgroup_schoenflies": "432",
    "international_short": "F432",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 209,
    "choice": "",
    "international_full": "F 4 3 2",
    "hall_symbol": "F 4 2 3",
    "international": "F 4 3 2",
    "arithmetic_crystal_class_number": 66,
    "arithmetic_crystal_class_symbol": "432F"
  },
  "506": {
    "pointgroup_international": "O",
    "schoenflies": "O^4",
    "pointgroup_schoenflies": "432",
    "international_short": "F4_132",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 210,
    "choice": "",
    "international_full": "F 4_1 3 2",
    "hall_symbol": "F 4d 2 3",
    "international": "F 4_1 3 2",
    "arithmetic_crystal_class_number": 66,
    "arithmetic_crystal_class_symbol": "432F"
  },
  "507": {
    "pointgroup_international": "O",
    "schoenflies": "O^5",
    "pointgroup_schoenflies": "432",
    "international_short": "I432",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 211,
    "choice": "",
    "international_full": "I 4 3 2",
    "hall_symbol": "I 4 2 3",
    "international": "I 4 3 2",
    "arithmetic_crystal_class_number": 67,
    "arithmetic_crystal_class_symbol": "432I"
  },
  "508": {
    "pointgroup_international": "O",
    "schoenflies": "O^6",
    "pointgroup_schoenflies": "432",
    "international_short": "P4_332",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 212,
    "choice": "",
    "international_full": "P 4_3 3 2",
    "hall_symbol": "P 4acd 2ab 3",
    "international": "P 4_3 3 2",
    "arithmetic_crystal_class_number": 65,
    "arithmetic_crystal_class_symbol": "432P"
  },
  "509": {
    "pointgroup_international": "O",
    "schoenflies": "O^7",
    "pointgroup_schoenflies": "432",
    "international_short": "P4_132",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 213,
    "choice": "",
    "international_full": "P 4_1 3 2",
    "hall_symbol": "P 4bd 2ab 3",
    "international": "P 4_1 3 2",
    "arithmetic_crystal_class_number": 65,
    "arithmetic_crystal_class_symbol": "432P"
  },
  "510": {
    "pointgroup_international": "O",
    "schoenflies": "O^8",
    "pointgroup_schoenflies": "432",
    "international_short": "I4_132",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ]
    ],
    "number": 214,
    "choice": "",
    "international_full": "I 4_1 3 2",
    "hall_symbol": "I 4bd 2c 3",
    "international": "I 4_1 3 2",
    "arithmetic_crystal_class_number": 67,
    "arithmetic_crystal_class_symbol": "432I"
  },
  "511": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^1",
    "pointgroup_schoenflies": "-43m",
    "international_short": "P-43m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 215,
    "choice": "",
    "international_full": "P -4 3 m",
    "hall_symbol": "P -4 2 3",
    "international": "P -4 3 m",
    "arithmetic_crystal_class_number": 68,
    "arithmetic_crystal_class_symbol": "-43mP"
  },
  "512": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^2",
    "pointgroup_schoenflies": "-43m",
    "international_short": "F-43m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 216,
    "choice": "",
    "international_full": "F -4 3 m",
    "hall_symbol": "F -4 2 3",
    "international": "F -4 3 m",
    "arithmetic_crystal_class_number": 69,
    "arithmetic_crystal_class_symbol": "-43mF"
  },
  "513": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^3",
    "pointgroup_schoenflies": "-43m",
    "international_short": "I-43m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 217,
    "choice": "",
    "international_full": "I -4 3 m",
    "hall_symbol": "I -4 2 3",
    "international": "I -4 3 m",
    "arithmetic_crystal_class_number": 70,
    "arithmetic_crystal_class_symbol": "-43mI"
  },
  "514": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^4",
    "pointgroup_schoenflies": "-43m",
    "international_short": "P-43n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 218,
    "choice": "",
    "international_full": "P -4 3 n",
    "hall_symbol": "P -4n 2 3",
    "international": "P -4 3 n",
    "arithmetic_crystal_class_number": 68,
    "arithmetic_crystal_class_symbol": "-43mP"
  },
  "515": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^5",
    "pointgroup_schoenflies": "-43m",
    "international_short": "F-43c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 219,
    "choice": "",
    "international_full": "F -4 3 c",
    "hall_symbol": "F -4c 2 3",
    "international": "F -4 3 c",
    "arithmetic_crystal_class_number": 69,
    "arithmetic_crystal_class_symbol": "-43mF"
  },
  "516": {
    "pointgroup_international": "Td",
    "schoenflies": "Td^6",
    "pointgroup_schoenflies": "-43m",
    "international_short": "I-43d",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.25]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 220,
    "choice": "",
    "international_full": "I -4 3 d",
    "hall_symbol": "I -4bd 2c 3",
    "international": "I -4 3 d",
    "arithmetic_crystal_class_number": 70,
    "arithmetic_crystal_class_symbol": "-43mI"
  },
  "517": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^1",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pm-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 221,
    "choice": "",
    "international_full": "P 4/m -3 2/m",
    "hall_symbol": "-P 4 2 3",
    "international": "P m -3 m",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "518": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^2",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pn-3n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 222,
    "choice": "1",
    "international_full": "P 4/n -3 2/n",
    "hall_symbol": "P 4 2 3 -1n",
    "international": "P n -3 n",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "519": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^2",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pn-3n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 222,
    "choice": "2",
    "international_full": "P 4/n -3 2/n",
    "hall_symbol": "-P 4a 2bc 3",
    "international": "P n -3 n",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "520": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^3",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pm-3n",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 223,
    "choice": "",
    "international_full": "P 4_2/m -3 2/n",
    "hall_symbol": "-P 4n 2 3",
    "international": "P m -3 n",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "521": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^4",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pn-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.0, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 224,
    "choice": "1",
    "international_full": "P 4_2/n -3 2/m",
    "hall_symbol": "P 4n 2 3 -1n",
    "international": "P n -3 m",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "522": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^4",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Pn-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 224,
    "choice": "2",
    "international_full": "P 4_2/n -3 2/m",
    "hall_symbol": "-P 4bc 2bc 3",
    "international": "P n -3 m",
    "arithmetic_crystal_class_number": 71,
    "arithmetic_crystal_class_symbol": "m-3mP"
  },
  "523": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^5",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fm-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 225,
    "choice": "",
    "international_full": "F 4/m -3 2/m",
    "hall_symbol": "-F 4 2 3",
    "international": "F m -3 m",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "524": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^6",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fm-3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 226,
    "choice": "",
    "international_full": "F 4/m -3 2/c",
    "hall_symbol": "-F 4c 2 3",
    "international": "F m -3 c",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "525": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^7",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fd-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 227,
    "choice": "1",
    "international_full": "F 4_1/d -3 2/m",
    "hall_symbol": "F 4d 2 3 -1d",
    "international": "F d -3 m",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "526": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^7",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fd-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 227,
    "choice": "2",
    "international_full": "F 4_1/d -3 2/m",
    "hall_symbol": "-F 4vw 2vw 3",
    "international": "F d -3 m",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "527": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^8",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fd-3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.75, 0.25, 0.25],
      [0.5, 0.5, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.75, 0.75, 0.75],
      [0.0, 0.0, 0.5],
      [0.75, 0.25, 0.25],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.0],
      [0.25, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.0],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.5],
      [0.25, 0.25, 0.75],
      [0.5, 0.0, 0.0],
      [0.75, 0.75, 0.75],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.0, 0.5, 0.0]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 228,
    "choice": "1",
    "international_full": "F 4_1/d -3 2/c",
    "hall_symbol": "F 4d 2 3 -1cd",
    "international": "F d -3 c",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "528": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^8",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Fd-3c",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.25, 0.75],
      [0.0, 0.25, 0.75],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.0, 0.25],
      [0.75, 0.0, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.75, 0.25, 0.0],
      [0.75, 0.25, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.0, 0.25],
      [0.75, 0.0, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.25, 0.75, 0.0],
      [0.25, 0.75, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.0, 0.75, 0.25],
      [0.0, 0.75, 0.25],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.0],
      [0.25, 0.75, 0.0],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.0, 0.25, 0.75],
      [0.0, 0.25, 0.75],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.25, 0.0, 0.75],
      [0.25, 0.0, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.75, 0.25],
      [0.0, 0.75, 0.25],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.75, 0.5, 0.75],
      [0.75, 0.5, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.75, 0.75, 0.5],
      [0.75, 0.75, 0.5],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.5, 0.75],
      [0.75, 0.5, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.25, 0.25, 0.5],
      [0.25, 0.25, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.0, 0.25, 0.75],
      [0.0, 0.25, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.25, 0.5],
      [0.25, 0.25, 0.5],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.0, 0.75, 0.25],
      [0.0, 0.75, 0.25],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.25, 0.5, 0.25],
      [0.25, 0.5, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.25, 0.25],
      [0.5, 0.25, 0.25],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.0, 0.75],
      [0.25, 0.0, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.25, 0.0, 0.25],
      [0.25, 0.0, 0.25],
      [0.25, 0.25, 0.5],
      [0.25, 0.25, 0.5],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.0, 0.75],
      [0.25, 0.0, 0.75],
      [0.0, 0.75, 0.75],
      [0.0, 0.75, 0.75],
      [0.75, 0.75, 0.5],
      [0.75, 0.75, 0.5],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.5, 0.75, 0.75],
      [0.5, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.5],
      [0.75, 0.75, 0.5],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.5, 0.25, 0.25],
      [0.5, 0.25, 0.25],
      [0.75, 0.25, 0.5],
      [0.75, 0.25, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.75, 0.0, 0.25],
      [0.75, 0.0, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.75, 0.75],
      [0.5, 0.75, 0.75],
      [0.25, 0.75, 0.5],
      [0.25, 0.75, 0.5],
      [0.25, 0.5, 0.25],
      [0.25, 0.5, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.25, 0.5, 0.75],
      [0.25, 0.5, 0.75],
      [0.25, 0.75, 0.0],
      [0.25, 0.75, 0.0],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.25, 0.5, 0.25],
      [0.25, 0.5, 0.25],
      [0.0, 0.25, 0.25],
      [0.0, 0.25, 0.25],
      [0.75, 0.25, 0.0],
      [0.75, 0.25, 0.0],
      [0.75, 0.5, 0.25],
      [0.75, 0.5, 0.25],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.0],
      [0.25, 0.25, 0.0],
      [0.5, 0.25, 0.25],
      [0.5, 0.25, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.0],
      [0.75, 0.25, 0.0],
      [0.75, 0.0, 0.75],
      [0.75, 0.0, 0.75],
      [0.5, 0.75, 0.75],
      [0.5, 0.75, 0.75],
      [0.75, 0.75, 0.0],
      [0.75, 0.75, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.5, 0.25, 0.75],
      [0.5, 0.25, 0.75],
      [0.75, 0.5, 0.75],
      [0.75, 0.5, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 228,
    "choice": "2",
    "international_full": "F 4_1/d -3 2/c",
    "hall_symbol": "-F 4cvw 2vw 3",
    "international": "F d -3 c",
    "arithmetic_crystal_class_number": 72,
    "arithmetic_crystal_class_symbol": "m-3mF"
  },
  "529": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^9",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Im-3m",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 229,
    "choice": "",
    "international_full": "I 4/m -3 2/m",
    "hall_symbol": "-I 4 2 3",
    "international": "I m -3 m",
    "arithmetic_crystal_class_number": 73,
    "arithmetic_crystal_class_symbol": "m-3mI"
  },
  "530": {
    "pointgroup_international": "Oh",
    "schoenflies": "Oh^10",
    "pointgroup_schoenflies": "m-3m",
    "international_short": "Ia-3d",
    "translations": [
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.25, 0.25],
      [0.75, 0.25, 0.25],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.0, 0.0, 0.0],
      [0.0, 0.0, 0.0],
      [0.75, 0.25, 0.25],
      [0.75, 0.25, 0.25],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.25, 0.25, 0.25],
      [0.25, 0.25, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.0, 0.5, 0.0],
      [0.0, 0.5, 0.0],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.75, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.25, 0.25],
      [0.75, 0.25, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.75, 0.75, 0.25],
      [0.75, 0.75, 0.25],
      [0.0, 0.0, 0.5],
      [0.0, 0.0, 0.5],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.0, 0.5, 0.5],
      [0.0, 0.5, 0.5],
      [0.75, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.25, 0.75, 0.25],
      [0.25, 0.75, 0.25],
      [0.5, 0.5, 0.5],
      [0.5, 0.5, 0.5],
      [0.25, 0.75, 0.75],
      [0.25, 0.75, 0.75],
      [0.5, 0.0, 0.0],
      [0.5, 0.0, 0.0],
      [0.75, 0.25, 0.75],
      [0.75, 0.25, 0.75],
      [0.5, 0.0, 0.5],
      [0.5, 0.0, 0.5],
      [0.75, 0.75, 0.75],
      [0.75, 0.75, 0.75],
      [0.5, 0.5, 0.0],
      [0.5, 0.5, 0.0],
      [0.25, 0.25, 0.75],
      [0.25, 0.25, 0.75]
    ],
    "rotations": [
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, -1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, 1]
      ],
      [
        [-1, 0, 0],
        [0, 1, 0],
        [0, 0, -1]
      ],
      [
        [1, 0, 0],
        [0, -1, 0],
        [0, 0, 1]
      ],
      [
        [0, 1, 0],
        [1, 0, 0],
        [0, 0, -1]
      ],
      [
        [0, -1, 0],
        [-1, 0, 0],
        [0, 0, 1]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, 1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, -1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, -1],
        [-1, 0, 0],
        [0, 1, 0]
      ],
      [
        [0, 0, 1],
        [1, 0, 0],
        [0, -1, 0]
      ],
      [
        [0, 0, -1],
        [0, 1, 0],
        [1, 0, 0]
      ],
      [
        [0, 0, 1],
        [0, -1, 0],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, -1],
        [1, 0, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, 1],
        [-1, 0, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, -1],
        [0, -1, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, 1],
        [0, 1, 0]
      ],
      [
        [0, 1, 0],
        [0, 0, -1],
        [-1, 0, 0]
      ],
      [
        [0, -1, 0],
        [0, 0, 1],
        [1, 0, 0]
      ],
      [
        [1, 0, 0],
        [0, 0, -1],
        [0, 1, 0]
      ],
      [
        [-1, 0, 0],
        [0, 0, 1],
        [0, -1, 0]
      ]
    ],
    "number": 230,
    "choice": "",
    "international_full": "I 4_1/a -3 2/d",
    "hall_symbol": "-I 4bd 2c 3",
    "international": "I a -3 d",
    "arithmetic_crystal_class_number": 73,
    "arithmetic_crystal_class_symbol": "m-3mI"
  }
}
